<template>
  <v-container grid-list-md text-center v-resize="checkMobile" :style="isMobile ? 'padding: 3px !important;' : ''" data-testid="new-booking-page">
    <template v-if="!initialLoading">
    <v-card>
      <v-card-title id="registration-step-48">
        <v-row>
          <v-col cols="12" md="6" v-if="!booking.technical || !isMobile" class="d-flex justify-center align-center">
            <h3>{{ $t("bookings.new_booking") }}</h3>
          </v-col>
          <v-col cols="12" md="6"
            :class="isMobile ? 'd-flex justify-center align-center' : 'd-flex justify-end align-center'">
            <v-switch v-model="booking.technical" :label="$t('bookings.tech')" hide-details dense class="my-auto">
            </v-switch>
            <v-switch v-if="booking.technical" v-model="booking.repair" class="ml-2 my-auto" color="warning"
              :label="$t('custom.repair')" hide-details dense>
            </v-switch>
          </v-col>
        </v-row>
      </v-card-title>
      <hr class="mb-2 mt-2" />
      <v-card-text v-if="!booking.technical && set_car" style="padding-bottom: 0px !important">
        <div
          v-if="set_car && booking.days && !booking.technical && !booking.hourly && !booking.weekly && !booking.monthly"
          class="registration-step-60" id="calculation1">
          {{ $t("bookings.days_size") }}:
          <span id="days" data-cy="days">{{ booking.days }}</span>.
          <span v-if="tariff">{{ $t("bookings.tariff") }}: {{ tariff.name }}.</span>
          {{ $t("bookings.calc_cost") }}:
          <span id="price_no_sale" data-cy="price_no_sale">{{ booking.price_no_sale }}</span>{{ currency }}.
          <span v-if="booking.sale > 0 || booking.sale_cash > 0">{{ $t("bookings.cost_sale") }}:
            <span id="selected_price" data-cy="selected_price">{{ booking.selected_price }}</span>{{ currency }}.
          </span>
          <span v-if="
            tariff &&
            (tariff.sum > 0 ||
              tariff.sum < 0 ||
              tariff.percent > 0 ||
              tariff.percent < 0)
          ">{{ $t("bookings.cost_tariff") }}:
            <span id="selected_price" data-cy="selected_price">{{ booking.selected_price }}</span>{{ currency }}</span>
        </div>
        <div v-if="set_car && booking.hourly_hours && !booking.technical && booking.hourly">
          {{ $t("bookings.hours_count") }}:
          <span id="hours" data-cy="hours">{{ booking.hourly_hours }}</span>.
          <span v-if="tariff">{{ $t("bookings.tariff") }}: {{ tariff.name }}.</span>
          {{ $t("bookings.calc_cost") }}:
          <span id="price_no_sale" data-cy="price_no_sale">{{ booking.price_no_sale }}</span>{{ currency }}.
          <span v-if="booking.sale > 0 || booking.sale_cash > 0">{{ $t("bookings.cost_sale") }}:
            <span id="selected_price" data-cy="selected_price">{{ booking.selected_price }}</span>{{ currency }}.
          </span>
          <span v-if="
            tariff &&
            (tariff.sum > 0 ||
              tariff.sum < 0 ||
              tariff.percent > 0 ||
              tariff.percent < 0)
          ">{{ $t("bookings.cost_tariff") }}:
            <span id="selected_price" data-cy="selected_price">{{ booking.selected_price }}</span>{{ currency }}</span>
        </div>
        <div v-if="set_car && booking.weekly_weeks && !booking.technical && booking.weekly">
          {{ $t("bookings.weeks_count") }}:
          <span id="weeks">{{ booking.weekly_weeks }}</span>.
          <span v-if="tariff">{{ $t("bookings.tariff") }}: {{ tariff.name }}.</span>
          {{ $t("bookings.calc_cost") }}:
          <span id="price_no_sale" data-cy="price_no_sale">{{ booking.price_no_sale }}</span>{{ currency }}.
          <span v-if="booking.sale > 0 || booking.sale_cash > 0">{{ $t("bookings.cost_sale") }}:
            <span id="selected_price" data-cy="selected_price">{{ booking.selected_price }}</span>{{ currency }}.
          </span>
          <span v-if="
            tariff &&
            (tariff.sum > 0 ||
              tariff.sum < 0 ||
              tariff.percent > 0 ||
              tariff.percent < 0)
          ">{{ $t("bookings.cost_tariff") }}:
            <span id="selected_price" data-cy="selected_price">{{ booking.selected_price }}</span>{{ currency }}</span>
        </div>
        <div v-if="set_car && booking.monthly_months && !booking.technical && booking.monthly">
          {{ $t("bookings.months_count") }}:
          <span id="months">{{ booking.monthly_months }}</span>.
          <span v-if="tariff">{{ $t("bookings.tariff") }}: {{ tariff.name }}.</span>
          {{ $t("bookings.calc_cost") }}:
          <span id="price_no_sale" data-cy="price_no_sale">{{ booking.price_no_sale }}</span>{{ currency }}.
          <span v-if="booking.sale > 0 || booking.sale_cash > 0">{{ $t("bookings.cost_sale") }}:
            <span id="selected_price" data-cy="selected_price">{{ booking.selected_price }}</span>{{ currency }}.
          </span>
          <span v-if="
            tariff &&
            (tariff.sum > 0 ||
              tariff.sum < 0 ||
              tariff.percent > 0 ||
              tariff.percent < 0)
          ">{{ $t("bookings.cost_tariff") }}:
            <span id="selected_price" data-cy="selected_price">{{ booking.selected_price }}</span>{{ currency }}</span>
        </div>
        <v-flex md12 v-if="!booking.technical">
          <p v-if="booking.total" class="font-weight-bold">
            {{ $t("bookings.for_pay_2") }}: {{ $t("custom.rent_low") }}
            {{ booking.rental_cost }}{{ currency }}
            <span v-if="booking.delivery > 0">+ {{ $t("custom.delivery_low") }} {{ booking.delivery
              }}{{ currency }}
            </span>
            <span v-if="booking.delivery_end > 0">+ {{ $t("custom.checkout_low") }} {{ booking.delivery_end
              }}{{ currency }}
            </span>
            <span v-if="booking.clean_payment > 0">+ {{ $t("custom.clean_low") }} {{ booking.clean_payment
              }}{{ currency }}
            </span>
            <span v-if="booking.hours_cost > 0">+ {{ $t("custom.add_hours_low") }} {{ booking.hours_cost
              }}{{ currency }}
            </span>
            <span v-if="booking.equipment > 0">+ {{ $t("custom.equipment_low") }} {{ booking.equipment
              }}{{ currency }}
            </span>
            <!-- FT-102 REQ-07: выбранное каталожное оборудование — в превью до создания брони -->
            <span v-if="ft102AddonsCost > 0">+ {{ $t("booking_addons.title_low") }} {{ ft102AddonsCost
              }}{{ currency }}
            </span>
            <span v-if="showInsurance && (booking.insurance > 0)">+ {{ $t("custom.insurance_low") }} {{ booking.insurance
              }}{{ currency }}
            </span>
            <span v-if="booking.add_drivers_cost > 0">+ {{ $t("custom.add_drivers_low") }} {{ booking.add_drivers_cost
              }}{{ currency }}
            </span>
            <span v-if="booking.other > 0">+ {{ $t('custom.other_low') }} {{ booking.other }}{{ currency }}
            </span>
            <span data-cy="deposit">
              + {{ $t("custom.deposit_low") }} {{ currentDeposit() }}{{ currency }}
            </span>
            <span data-cy="total">
              = {{ $t("custom.total") }} {{ booking.total + ft102AddonsCost + currentDeposit() }}{{ currency }}
            </span>
          </p>
        </v-flex>
        <div v-if="set_car && booking.additional_hours > 0 && !booking.technical">
          {{ $t("custom.add_hours") }}:
          <span id="additional_hours" data-cy="additional_hours">{{ booking.additional_hours }}</span>. {{
            $t("custom.price_hour") }}: {{
            booking.price_hour
          }}{{ currency }}. {{ $t("custom.for_add_hours") }}:
          <span id="hours_cost" data-cy="hours_cost">{{ booking.hours_cost }}</span>{{ currency }}
        </div>
        <!-- Почему добавлены сутки — из ответа движка (units.extra_day_reason). Прежний
             warningAddOneDay нигде не выставлялся, т.е. при создании брони пользователь
             не получал объяснения вовсе (staging 2026-07-31). -->
        <div v-if="extraDayReasonText && !booking.technical" class="red--text" id="warning_more_then_day">
          {{ extraDayReasonText }}
        </div>
        <div v-else-if="warningAddOneDay && !booking.technical" class="red--text" id="warning_more_then_day">
          {{ $t("bookings.warn_add_day") }}
        </div>
        <div v-if="warningLessOneDay" class="red--text">
          {{ $t("bookings.warn_less_day") }}
        </div>
        <v-flex xs12 sm12 md12 v-if="
          !booking.technical &&
          selected_seasons &&
          selected_seasons.length > 0
        ">
          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header style="padding: 2px 0 !important">
                {{ $t("bookings.price_breakdown") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="grey--text text-caption" data-cy="season_mode" :data-mode="seasonModeKeyValue">
                  {{ $t("bookings.season_mode_label") }}: {{ seasonModeText }}
                </div>
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr v-for="item in selected_seasons" :key="item.index">
                        <th class="text-left">
                          {{ item.season.start_date }} -
                          {{ item.season.end_date }}
                          <span v-if="item.isBase" class="grey--text font-weight-regular">
                            ({{ $t("bookings.base_prices_row") }})
                          </span>
                        </th>
                        <td class="text-left" :data-cy="item.isBase ? 'days_in_base' : 'days_in_season'">
                          {{ item.days }}
                        </td>
                        <td class="text-right" :data-cy="item.isBase ? 'price_in_base' : 'price_in_season'">
                          {{ item.price }}
                          <!-- FT-216 REQ-04, OQ-04: процент поправки на даты — суффикс в ячейке цены -->
                          <span v-if="item.adjustmentPercent" class="grey--text text-caption ml-1" data-cy="adjustment_percent"
                            :title="$t('dynamic_pricing.adjustment_hint')">{{ item.adjustmentPercent }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
      </v-card-text>
      <v-card-text style="padding-top: 0px !important">
        <v-form>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12 sm6 md6 id="select_car" class="registration-step-49">
                <h4 v-if="!isMobile" class="mt-2">{{ $t("custom.car_long", { msg: object_name_for_label }) }}</h4>
                <v-autocomplete v-model="selected_car_id" item-text="code" item-value="id" data-cy="select_car"
                  :prepend-icon="isLoadingGetCar ? 'mdi-sync' : 'mdi-car'" flat @change="getCar" hide-no-data
                  hide-details :loading="isLoadingGetCar" :label="$t('custom.select_car')" :items="cars">
                  <template slot="selection" slot-scope="data">
                    {{ carLabel(data.item) }}
                  </template>
                  <template slot="item" slot-scope="data">
                    {{ carLabel(data.item) }}
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <!-- На мобильном поля стоят друг под другом, и заголовок повторяет
                     label поля («Клиент» над «Выберите клиента…»). На десктопе поля
                     идут рядом двумя колонками — там заголовок называет колонку. -->
                <h4 v-if="!isMobile" class="mt-2">{{ $t("custom.client") }}</h4>
                <div class="d-flex" id="select_client" v-if="showClients">
                  <v-autocomplete v-model="client" item-text="fullname" item-value="id" :loading="isLoadingClients"
                    :search-input.sync="search" data-cy="select_client" clearable flat hide-no-data hide-details
                    :label="$t('custom.select_client')" :items="clients" :prepend-icon="isLoadingClients ? 'mdi-sync' : 'mdi-account-box'
                      " return-object :error="showClientProblems">
                  </v-autocomplete>
                  <v-icon id="registration-step-51" class="mt-3" @click="
                    (newClientDialog = true),
                    (client = { category: 'Новый', country: 'Россия' })
                    " v-tooltip="{
                      content: $t('custom.add_new_client'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }">mdi-account-plus-outline</v-icon>
                </div>
                <v-row v-if="showClientProblems">
                  <v-col cols="12">
                    <v-alert type="error">
                      {{ client.problems_description }}
                    </v-alert>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="d-flex align-center">
                    <v-text-field slot="activator" v-model="client.fio" :label="$t('custom.created_client')" disabled
                      v-if="!showClients && client && !client.entity" id="registration-step-57"></v-text-field>
                    <v-text-field slot="activator" v-model="client.entity_name" :label="$t('custom.created_client')"
                      disabled v-if="!showClients && client && client.entity" id="registration-step-57"></v-text-field>
                    <v-icon v-if="!showClients && client && client.id" class="ml-2" @click="toClientCard(client)">
                      mdi-eye
                    </v-icon>
                  </v-col>
                </v-row>
              </v-flex>
            </v-layout>
            <v-row wrap class="mt-4" v-if="selected_car_id">
              <v-flex xs12 sm12 md12 id="registration-step-58" v-if="!isLoadingGetCar">
                <vc-date-picker v-model="datesRange" is-expanded is-range mode="dateTime" :model-config="calendarConfig"
                  :attributes="calendar_attributes" is24hr title-position="left"
                  :columns="$screens({ default: 1, md: 2, lg: 4 })" class="flex d-flex md12 p-0" :locale="$i18n.locale"
                  :is-dark="$vuetify.theme.dark">
                </vc-date-picker>
              </v-flex>
              <v-flex xs12 sm12 md12 id="registration-step-58" v-if="isLoadingGetCar">
                <v-skeleton-loader type="card" height="200px"></v-skeleton-loader>
              </v-flex>
            </v-row>
            <v-row wrap class="mt-4" id="registration-step-61">
              <v-flex xs12 sm6 md6>
                <h4 class="mt-2">{{ $t("bookings.start_place") }}</h4>
                <v-text-field @input="extra = true" v-model="booking.location_start" prepend-icon="mdi-map-marker"
                  :label="$t('bookings.start_place')"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <h4 class="mt-2">{{ $t("bookings.end_place") }}</h4>
                <v-text-field @input="extra = true" v-model="booking.location_end" prepend-icon="mdi-map-marker"
                  :label="$t('bookings.end_place')"></v-text-field>
              </v-flex>
            </v-row>
            <v-row v-if="!booking.technical" wrap class="align-center" id="registration-step-62">
              <v-col cols="12" md="2">
                <v-switch :label="$t('bookings.tariff')" v-model="showTariff" v-tooltip="{
                  content: $t('bookings.tariff_desc'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 500,
                    hide: 500,
                  },
                }"></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch :label="$t('bookings.sale')" v-model="sale" v-tooltip="{
                  content: $t('bookings.sale_desc'),
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 500,
                    hide: 500,
                  },
                }"></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch :input-value="showManualEditing" color="error" :key="'manual-sw-' + modeSwitchKey"
                  @change="onManualSwitchToggle"
                  :label="$t('bookings.calc_manual')" v-tooltip="{
                    content: $t('bookings.calc_manual_data'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }"></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch :label="$t('bookings.add_services')" v-model="extra"></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch v-model="showDescription" :label="$t('bookings.add_info_short')"></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-switch v-model="showAddDrivers" @change="extra = true" :label="$t('bookings.drivers')"
                  v-tooltip="{
                    content: $t('bookings.add_drivers'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }"></v-switch>
              </v-col>
            </v-row>
            <v-row v-if="showManualEditing || manual_editing || showAddDrivers || extra || sale || showTariff" wrap
              justify-space-around class="align-center">
              <v-col cols="12" v-if="showManualEditing || manual_editing" class="align-center">
                <v-row>
                  <v-col cols="12">
                    <p class="red--text">{{ $t("bookings.warn_manual_2") }} {{ $t("bookings.warn_manual_dates") }}</p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field v-model.number="booking.days" :value="booking.days"
                      :label="$t('bookings.days_count')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field v-model.number="booking.selected_price" :value="booking.selected_price"
                      :label="$t('bookings.day_price')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field v-model.number="booking.rental_cost" :value="booking.rental_cost"
                      :label="$t('bookings.cost_for_day')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field v-model.number="booking.total" :value="booking.total"
                      :label="$t('bookings.cost_without_deposit')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field v-model.number="booking.deposit" :value="booking.deposit"
                      :label="$t('bookings.deposit')" @input="ft102DepositTouched = true"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field v-model.number="booking.additional_hours" :value="booking.additional_hours"
                      :label="$t('bookings.add_hours_count')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field v-model.number="booking.price_hour" :value="booking.price_hour"
                      :label="$t('bookings.price_for_hour')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field v-model.number="booking.hours_cost" :value="booking.hours_cost"
                      :label="$t('custom.for_add_hours')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field v-model.number="booking.delivery" :value="booking.delivery"
                      :label="$t('bookings.delivery')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field v-model.number="booking.delivery_end" :value="booking.delivery_end"
                      :label="$t('bookings.checkout')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field v-model.number="booking.equipment" :value="booking.equipment"
                      :label="$t('bookings.add_equipment')"
                      :hint="ft102CatalogCount > 0 ? $t('booking_addons.legacy_equipment_hint') : ''"
                      persistent-hint></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2" v-if="showInsurance">
                    <v-text-field v-model.number="booking.insurance" :value="booking.insurance"
                      :label="$t('bookings.add_insurance')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field v-model.number="booking.clean_payment" :value="booking.clean_payment"
                      :label="$t('bookings.clean')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field v-model.number="booking.add_drivers_cost" :value="booking.add_drivers_cost"
                      :label="$t('bookings.add_drivers_small')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field v-model.number="booking.other" :value="booking.other"
                      :label="$t('bookings.other')"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="showManualEditing || manual_editing" class="align-center">
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="booking.last_name" :label="$t('bookings.client_lastname')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="booking.first_name" :label="$t('bookings.client_name')"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="booking.middle_name"
                      :label="$t('bookings.client_middlename')"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="showTariff">
                <h4 class="mt-2">{{ $t("bookings.tariff") }}</h4>
                <v-select v-model="selected_tariff" :items="tariffs" item-text="fullname" item-value="id"
                  :label="$t('bookings.tariff')"></v-select>
              </v-col>
              <v-col cols="12" v-if="showAddDrivers" class="mb-3">
                <h3 class="mt-2">{{ $t("bookings.add_drivers") }}</h3>
                <div class="d-flex">
                  <v-autocomplete v-model="booking.add_drivers" multiple item-text="fullname" item-value="id"
                    :loading="isLoadingClientsAddDriver" :search-input.sync="search_add_driver" no-filter flat clearable
                    hide-no-data hide-details :label="$t('custom.select_client')" :items="clients_add_drivers"
                    prepend-icon="mdi-account-box">
                  </v-autocomplete>
                  <v-icon class="mt-3" @click="(newClientDialog = true), (client = [])" v-tooltip="{
                    content: $t('custom.add_new_client'),
                    placement: 'bottom-center',
                    classes: ['info'],
                    targetClasses: ['it-has-a-tooltip'],
                    delay: {
                      show: 500,
                      hide: 500,
                    },
                  }">mdi-account-plus-outline</v-icon>
                </div>
              </v-col>
              <v-col cols="12" v-if="extra && !booking.technical">
                <!-- Заголовок секции — тот же ключ, что у тумблера (custom.add_services
                     остаётся у инвойсов): экран не должен называть блок двумя именами -->
                <h3 class="mt-2">{{ $t("bookings.add_services") }}</h3>
              </v-col>
              <!-- FT-102: бронируемые допы — первыми в блоке услуг; легаси-блоки
                   оформлены такими же карточками (решение USER 2026-08-04) -->
              <v-col cols="12" v-show="extra && !booking.technical">
                <booking-addons-panel ref="addonsPanel" :start-date="dateStart" :end-date="dateEnd"
                  :units="ft102Units" @addons-deposit-changed="ft102OnAddonsDepositChanged"
                  @addons-cost-changed="ft102AddonsCost = $event.value"
                  @addons-loaded="ft102CatalogCount = $event"
                  @draft-pricing-changed="ft102OnDraftPricingChanged">
                </booking-addons-panel>
              </v-col>
              <v-col cols="12" v-if="extra && !booking.technical && ft102CatalogCount === 0">
                <v-card outlined class="pa-3">
                  <div class="d-flex align-center mb-1">
                    <v-icon small class="mr-2">mdi-baby-carriage</v-icon>
                    <h4 class="mb-0">{{ $t("bookings.add_equipment") }}</h4>
                  </div>
                  <div :class="isMobile ? '' : 'd-flex flex-wrap'" style="column-gap: 24px">
                    <v-checkbox dense hide-details :label="$t('bookings.baby_chair')" v-model="booking.chair"></v-checkbox>
                    <v-checkbox dense hide-details :label="$t('bookings.small_baby_chair')" v-model="booking.chair_less_1_year"></v-checkbox>
                    <v-checkbox dense hide-details :label="$t('bookings.booster')" v-model="booking.booster"></v-checkbox>
                    <v-checkbox dense hide-details :label="$t('bookings.navigator')" v-model="booking.navigator"></v-checkbox>
                    <v-checkbox dense hide-details :label="$t('bookings.mp3')" v-model="booking.mp3"></v-checkbox>
                    <v-checkbox dense hide-details :label="$t('bookings.charger')" v-model="booking.charger" v-tooltip="{
                      content: $t('bookings.charger_desc'),
                      placement: 'bottom-center',
                      classes: ['info'],
                      targetClasses: ['it-has-a-tooltip'],
                      delay: {
                        show: 500,
                        hide: 500,
                      },
                    }"></v-checkbox>
                  </div>
                  <div v-if="booking.chair || booking.chair_less_1_year || booking.booster"
                    :class="isMobile ? '' : 'd-flex'" style="column-gap: 24px">
                    <v-text-field :disabled="!booking.chair && !booking.chair_less_1_year" v-model="booking.chairs_quantity"
                      :label="$t('bookings.baby_chair_qnt')" dense hide-details class="mt-2"
                      style="max-width: 220px"></v-text-field>
                    <v-text-field :disabled="!booking.booster" v-model="booking.boosters_quantity"
                      :label="$t('bookings.booster_qnt')" dense hide-details class="mt-2"
                      style="max-width: 220px"></v-text-field>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="showInsurance && extra && !booking.technical">
                <v-card outlined class="pa-3">
                  <div class="d-flex align-center mb-1">
                    <v-icon small class="mr-2">mdi-shield-car</v-icon>
                    <h4 class="mb-0">{{ $t("bookings.extra_insurance") }}</h4>
                  </div>
                  <div :class="isMobile ? '' : 'd-flex flex-wrap'" style="column-gap: 24px">
                    <v-checkbox dense hide-details :label="$t('bookings.kasko')" v-model="booking.kasko"></v-checkbox>
                    <v-checkbox dense hide-details :label="$t('bookings.super_kasko')" v-model="booking.super_kasko"></v-checkbox>
                    <v-checkbox dense hide-details :label="$t('bookings.theft')" v-model="booking.theft"></v-checkbox>
                    <v-checkbox dense hide-details :label="$t('bookings.no_franchise')" v-model="booking.no_franchise"></v-checkbox>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" v-if="sale">
                <h3 class="mt-2">{{ $t("bookings.edit_sale_2") }}</h3>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="sale">
                <v-text-field v-model.number="booking.sale" @blur="requestQuote()"
                  :label="$t('bookings.edit_sale_percent')"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="sale">
                <v-text-field v-model.number="booking.sale_cash" @blur="requestQuote()"
                  :label="$t('bookings.edit_sale_rub', { msg: currency })"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="sale">
                <v-text-field v-model.number="booking.rental_cost_sale" @blur="requestQuote()"
                  :label="$t('bookings.edit_sale_rent_percent')"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" v-if="sale">
                <v-text-field v-model.number="booking.rental_cost_sale_cash" @blur="requestQuote()"
                  :label="$t('bookings.edit_sale_rent_rub', { msg: currency })"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-if="extra && !booking.technical">
                <h3 class="mt-2">{{ $t("bookings.add_services_cost") }}</h3>
              </v-col>
              <!-- Все 7 сумм — одной строкой (решение USER 2026-08-05): 7 полей не
                   ложатся в 12-колоночную сетку, поэтому flex-раскладка; на узких
                   экранах поля переносятся по min-width -->
              <v-col cols="12" v-if="extra && !booking.technical">
                <div class="d-flex flex-wrap" style="column-gap: 16px">
                  <v-text-field class="flex-grow-1" style="min-width: 120px" v-model.number="booking.delivery"
                    @blur="requestQuote()" :label="$t('bookings.delivery_cost')"></v-text-field>
                  <v-text-field class="flex-grow-1" style="min-width: 120px" v-model.number="booking.delivery_end"
                    @blur="requestQuote()" :label="$t('bookings.checkout_cost')"></v-text-field>
                  <!-- hint без persistent — всплывает по фокусу, не раздувая строку -->
                  <v-text-field class="flex-grow-1" style="min-width: 120px" v-model.number="booking.equipment"
                    @blur="requestQuote()" :label="$t('bookings.equipment_cost')"
                    :hint="ft102CatalogCount > 0 ? $t('booking_addons.legacy_equipment_hint') : ''"></v-text-field>
                  <v-text-field v-if="showInsurance" class="flex-grow-1" style="min-width: 120px" v-model.number="booking.insurance"
                    @blur="requestQuote()" :label="$t('bookings.insurance_cost')"></v-text-field>
                  <v-text-field class="flex-grow-1" style="min-width: 120px" v-model.number="booking.clean_payment"
                    @blur="requestQuote()" :label="$t('bookings.clean')"></v-text-field>
                  <v-text-field class="flex-grow-1" style="min-width: 120px" v-model.number="booking.add_drivers_cost"
                    @blur="requestQuote()" :label="$t('bookings.drivers_cost')"></v-text-field>
                  <v-text-field class="flex-grow-1" style="min-width: 120px" v-model.number="booking.other"
                    @blur="requestQuote()" :label="$t('bookings.other')"></v-text-field>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="showDescription || booking.technical">
              <v-col cols="12">
                <v-textarea v-model="booking.description" v-if="showDescription || booking.technical" clearable
                  auto-grow rows="1" :label="$t('bookings.booking_desc')"></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="booking.custom_field_1" v-if="showDescription" clearable auto-grow rows="1"
                  :label="$t('bookings.template_field_1')"></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="booking.custom_field_2" v-if="showDescription" clearable auto-grow rows="1"
                  :label="$t('bookings.template_field_2')"></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-textarea v-model="booking.custom_field_3" v-if="showDescription" clearable auto-grow rows="1"
                  :label="$t('bookings.template_field_3')"></v-textarea>
              </v-col>
            </v-row>
            <v-row v-if="!booking.technical">
              <v-col cols="12">
                <p v-if="booking.total" class="font-weight-bold">
                  {{ $t("bookings.for_pay_2") }}: {{ $t("custom.rent_low") }}
                  {{ booking.rental_cost }}{{ currency }}
                  <span v-if="booking.delivery > 0">+ {{ $t("custom.delivery_low") }} {{ booking.delivery
                    }}{{ currency }}
                  </span>
                  <span v-if="booking.delivery_end > 0">+ {{ $t("custom.checkout_low") }} {{ booking.delivery_end
                    }}{{ currency }}
                  </span>
                  <span v-if="booking.hours_cost > 0">+ {{ $t("custom.add_hours_low") }} {{ booking.hours_cost
                    }}{{ currency }}
                  </span>
                  <span v-if="booking.equipment > 0">+ {{ $t("custom.equipment_low") }} {{ booking.equipment
                    }}{{ currency }}
                  </span>
                  <!-- FT-102 REQ-07: выбранное каталожное оборудование — в превью до создания брони -->
                  <span v-if="ft102AddonsCost > 0">+ {{ $t("booking_addons.title_low") }} {{ ft102AddonsCost
                    }}{{ currency }}
                  </span>
                  <span v-if="showInsurance && (booking.insurance > 0)">+ {{ $t("custom.insurance_low") }} {{ booking.insurance
                    }}{{ currency }}
                  </span>
                  <span v-if="booking.clean_payment > 0">+ {{ $t("custom.clean_low") }} {{ booking.clean_payment
                    }}{{ currency }}
                  </span>
                  <span v-if="booking.add_drivers_cost > 0">+ {{ $t("custom.add_drivers_low") }}
                    {{ booking.add_drivers_cost }}{{ currency }}
                  </span>
                  <span v-if="booking.other > 0">+ {{ $t("custom.other_low") }} {{ booking.other
                    }}{{ currency }}
                  </span>
                  <span>
                    + {{ $t("custom.deposit_low") }} {{ currentDeposit() }}{{ currency }}
                  </span>
                  <span>
                    = {{ $t("bookings.total") }}
                    {{ booking.total + ft102AddonsCost + currentDeposit() }}{{ currency }}
                  </span>
                </p>
              </v-col>
            </v-row>
            <v-row v-if="!booking.technical">
              <v-col cols="12" v-if="!isTaxiMode">
                <v-select v-model="booking_selected_type" :items="booking_types" :label="$t('bookings.booking_type')"
                  dense hide-details @change="rentTypeTouchedByUser = true">
                </v-select>
              </v-col>
              <v-col cols="12" v-if="company && company.can_select_agents">
                <v-autocomplete v-model="selected_agent_id" :items="agents" @focus="getAgents()" item-text="name"
                  item-value="id" :label="$t('agents.select_agent')" :loading="isLoadingGetAgents" dense hide-details>
                </v-autocomplete>
              </v-col>
              <!-- FT-193 REQ-01: способ продления доступен всем компаниям (раньше — список id) -->
              <v-col cols="12" v-if="company">
                <v-select v-model="booking_payments_type" :items="booking_payments_types"
                  :label="$t('bookings.booking_payments_type')" dense hide-details>
                </v-select>
              </v-col>
              <v-col cols="12"
                v-if="company && (company.id == 2 || company.id == 11072 || company.id == 9997 || company.id == 4) && isTaxiMode">
                <v-select v-model="booking_payments_type_taxi" :items="booking_payments_types_taxi" item-text="text"
                  item-value="value" :label="$t('taxi.payment_models.payment_model')" dense hide-details>
                </v-select>
              </v-col>
              <v-col cols="12"
                v-if="booking_payments_type_taxi == 1 || booking_payments_type_taxi == 2">
                <v-text-field v-model="taxi_commission_percent" :label="$t('taxi.payment_models.commission_percent')"
                  dense hide-details
                  :rules="[(v) => v >= 0 && v <= 100 || 'Процент должен быть от 0 до 100']"></v-text-field>
              </v-col>
              <v-col cols="12"
                v-if="booking_payments_type == 'periodic' && !booking.hourly && !booking.weekly && !booking.monthly">
                <v-select v-model="booking_payments_period" :items="booking_payments_periods"
                  :label="$t('bookings.booking_payments_period')" dense hide-details>
                </v-select>
              </v-col>
              <!-- FT-193: чем платить за продление; «баланс и карта» — только при работающем терминале Т-Банка -->
              <v-col cols="12" v-if="showPeriodicFunding">
                <v-select v-model="booking_periodic_funding" :items="booking_periodic_fundings"
                  :label="$t('bookings.periodic_funding')" data-testid="periodic-funding" dense hide-details>
                </v-select>
              </v-col>
            </v-row>
            <!-- Индикация «расчёт цены» живёт в кнопке Создать (:loading) —
                 отдельная временная строка сдвигала кнопки при каждом
                 пересчёте (manual QA 2026-07-13). -->
            <v-row v-if="!booking.technical && quoteStatus === 'error'">
              <v-col cols="12">
                <v-alert type="error" dense text data-cy="quote_error">{{ $t("bookings.quote_error") }}</v-alert>
              </v-col>
            </v-row>
            <!-- FT-166: причина по типу аренды + путь к исправлению. Даты
                 причиной no_price не бывают: движок падает, только когда пусты
                 и сезонная, и базовая строка под выбранный rental_type. -->
            <v-row v-if="!booking.technical && quoteStatus === 'no_price'">
              <v-col cols="12">
                <v-alert type="warning" dense text data-cy="quote_no_price">
                  <div>{{ $t(noPriceMessageKey) }}</div>
                  <div v-if="noPriceCanTryDaily" class="mt-1">{{ $t("bookings.quote_no_price_try_daily") }}</div>
                  <a v-if="isStaff && carPricesHref" :href="carPricesHref" target="_blank" rel="noopener"
                    class="d-inline-block mt-1" data-cy="quote_no_price_link" @click="onOpenCarPrices"
                    @auxclick="onOpenCarPrices">
                    {{ $t("bookings.quote_no_price_open_prices") }}
                  </a>
                  <div v-else class="mt-1">{{ $t("bookings.quote_no_price_ask_admin") }}</div>
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn id="registration-step-63" large color="success"
                  :loading="isLoading || (!booking.technical && quoteStatus === 'loading')" :disabled="!pricingReady"
                  data-cy="save_booking" @click.prevent="saveBooking()">
                  {{ $t("custom.create") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
    </template>
    <template v-else>
      <v-container>
        <v-skeleton-loader type="heading" class="mb-4" />
        <v-row>
          <v-col cols="12" md="6"><v-skeleton-loader type="list-item-two-line, image" /></v-col>
          <v-col cols="12" md="6"><v-skeleton-loader type="list-item-two-line, image" /></v-col>
        </v-row>
        <v-skeleton-loader type="article" class="mt-4" />
        <div class="d-flex justify-center mt-4">
          <v-skeleton-loader type="button" />
        </div>
      </v-container>
    </template>
    <!-- <v-card v-else>
      <h2>{{ $t("bookings.new_booking") }}</h2>
      <p>{{ $t("bookings.warn_balance") }}</p>
    </v-card> -->
    <v-dialog v-model="newClientDialog" :retain-focus="false" persistent max-width="1200px" :fullscreen="isMobile">
      <v-card v-if="client && (!short_client_view || show_full_fields)" data-testid="new-client-dialog">
        <v-card-title :class="isMobile ? 'pt-12' : ''">
          <v-row class="align-center justify-space-between">
            <v-col cols="12" class="d-flex justify-space-between align-center">
              <h4>
                {{ $t("custom.add_client_2") }}
              </h4>
              <v-icon @click="newClientDialog = false">mdi-close</v-icon>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="d-flex justify-center align-center">
              <v-switch v-model="client.entity" :label="$t('custom.company_client')" dense hide-details
                class="mr-1"></v-switch>
              <v-switch v-if="short_client_view" v-model="show_full_fields" :label="$t('clients.show_full_fields')"
                dense hide-details></v-switch>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text v-if="!client.entity">
          <v-row id="registration-step-52">
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model="client.lastname" :label="$t('bookings.lastname')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model="client.name" :label="$t('bookings.name')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model="client.middlename" :label="$t('bookings.middlename')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-select v-if="clients_sources" v-model="client.source" :items="clients_sources"
                :label="$t('custom.source')" outlined></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="3">
              <phone-field ref="clientPhoneField" v-model="client.phone" mode="strict"
                :default-country="phoneDefaultCountry" :label="$t('bookings.main_phone')" outlined
                @change="checkUniqClientPhone" />
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model="client.email" @blur="checkUniqClientEmail" :label="$t('custom.email')"
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model="birthday_non_format" @blur="checkAge(birthday_non_format)" v-mask="'##.##.####'"
                :label="$t('bookings.birthdate')" :placeholder="$t('bookings.birthdate_plc')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-select v-model="client.category" :items="customer_category" item-text="text" item-value="value"
                :label="$t('bookings.client_category')" :value="$t('customer_category.new')" outlined></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model="client.passport_series" :label="$t('custom.passport_series')"
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model="client.passport_number" :label="$t('custom.passport_number')"
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model="client.passport_issued" :label="$t('custom.passport_issued')"
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model="client.passport_issued_date" type="date" :label="$t('custom.passport_issued_date')"
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model="client.passport_expired_date" type="date"
                :label="$t('custom.passport_expired_date')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model="client.inn" :label="$t('custom.tax_number')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-autocomplete v-model="client.country" flat hide-no-data hide-details :label="$t('custom.country')"
                :items="countries" item-text="both" item-value="name" outlined>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model="client.city" :label="$t('custom.city')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model="client.address" :label="$t('custom.address')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-select v-model="client.lang" :items="languages" item-text="text" item-value="value"
                :label="$t('companies.locale')" :placeholder="$t('companies.locale_plc')" outlined></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6">
              <v-text-field v-model="client.driver_series" :label="$t('custom.license_series')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6">
              <v-text-field v-model="client.driver_number" :label="$t('custom.license_number')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model="client.driver_issued" :label="$t('custom.license_issued')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model="client.driver_issued_date" type="date" :label="$t('custom.driver_license_issued_date')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model="client.driver_expired_date" type="date" :label="$t('custom.driver_license_expired_date')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" md="12">
              <v-text-field v-model="client.taxi_license" :label="$t('custom.taxi_license')" outlined :style="user_role == 'guest' || user_role == 'partner'
                ? 'display: none;'
                : ''
                "></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="6">
              <v-text-field v-model="client.sale" :label="$t('custom.sale_perc')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6">
              <v-text-field v-model="client.sale_cash" :label="$t('custom.sale_rub', { currency: currency })"
                outlined></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea v-model="client.dop_info" clearable rows="1"
                :label="$t('other.add_client_info_2')"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text v-else>
          <v-row v-if="client">
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model.trim="client.entity_name" :label="$t('custom.company_name')"
                :placeholder="$t('custom.company_name_placeholder')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model.trim="client.short_entity_name" :label="$t('custom.company_name_short')"
                :placeholder="$t('custom.company_name_short_plc')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model.trim="client.reg_form" :label="$t('custom.reg_form')"
                :placeholder="$t('custom.reg_form_plc')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model.trim="client.inn" :label="$t('custom.tax_number')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model.trim="client.ogrn" :label="$t('custom.entity_number')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model.trim="client.ceo" :label="$t('custom.face')" :placeholder="$t('custom.face_plc')"
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <phone-field ref="clientPhoneField" v-model="client.entity_phone" mode="soft"
                :default-country="phoneDefaultCountry" :label="$t('custom.entity_phone')" outlined />
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2">
              <v-select v-model="client.country" :items="countries" :label="$t('custom.country')" item-text="both"
                item-value="name" outlined></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2">
              <v-text-field v-model.trim="client.city" :label="$t('custom.city')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-textarea v-model.trim="client.entity_adress" :label="$t('custom.entity_address')" outlined rows="1"
                auto-grow></v-textarea>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2">
              <v-select v-model="client.lang" :items="languages" item-text="text" item-value="value"
                :label="$t('companies.locale')" :placeholder="$t('companies.locale_plc')" outlined></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model.trim="client.acc_number" :label="$t('custom.entity_bank_number')"
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2">
              <v-text-field v-model.trim="client.bank" :label="$t('custom.bank_name')"
                :placeholder="$t('custom.bank_name_plc')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model.trim="client.korr" :label="$t('custom.bank_correspondent')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2">
              <v-text-field v-model.trim="client.bik" :label="$t('custom.bank_number')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2">
              <v-text-field v-model.trim="client.doc_number" :label="$t('custom.doc_number')" outlined></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="registration-step-56" color="success" :loading="isLoading" @click="submitClient()">{{ $t("custom.save") }}</v-btn>
          <v-btn @click="newClientDialog = false">{{
            $t("custom.close")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
      <v-card v-else data-testid="new-client-dialog">
        <v-card-title :class="isMobile ? 'pt-12' : ''">
          <v-row>
            <v-col cols="12" class="d-flex justify-space-between align-center">
              <h4>
                {{ $t("custom.add_client_2") }}
              </h4>
              <v-icon @click="newClientDialog = false">mdi-close</v-icon>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="d-flex justify-center align-center">
              <v-switch v-model="client.entity" :label="$t('custom.company_client')" dense hide-details
                class="mr-1"></v-switch>
              <v-switch v-if="short_client_view" v-model="show_full_fields" :label="$t('clients.show_full_fields')"
                dense hide-details></v-switch>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text v-if="!client.entity">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model="client.lastname" :label="$t('bookings.lastname')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model="client.name" :label="$t('bookings.name')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model="client.middlename" :label="$t('bookings.middlename')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-select v-if="clients_sources" v-model="client.source" :items="clients_sources"
                :label="$t('custom.source')" outlined></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <phone-field ref="clientPhoneField" v-model="client.phone" mode="strict"
                :default-country="phoneDefaultCountry" :label="$t('bookings.main_phone')" outlined
                @change="checkUniqClientPhone" />
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model="client.email" @blur="checkUniqClientEmail" :label="$t('custom.email')"
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model="birthday_non_format" @blur="checkAge(birthday_non_format)" v-mask="'##.##.####'"
                :label="$t('bookings.birthdate')" :placeholder="$t('bookings.birthdate_plc')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-select v-model="client.category" :items="customer_category" item-text="text" item-value="value"
                :label="$t('bookings.client_category')" :value="$t('customer_category.new')" outlined></v-select>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-row justify="center">
              <v-btn color="success" :loading="isLoading" @click="submitClient()">{{
                $t("custom.save")
              }}</v-btn>
            </v-row>
          </v-card-actions>
          <v-expansion-panels class="mb-3 mt-5">
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("clients.extra_fields") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="4">
                    <v-text-field v-model="client.passport_series" :label="$t('custom.passport_series')"
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4">
                    <v-text-field v-model="client.passport_number" :label="$t('custom.passport_number')"
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4">
                    <v-text-field v-model="client.passport_issued" :label="$t('custom.passport_issued')"
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4">
                    <v-text-field v-model="client.passport_issued_date" type="date"
                      :label="$t('custom.passport_issued_date')" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4">
                    <v-text-field v-model="client.passport_expired_date" type="date"
                      :label="$t('custom.passport_expired_date')" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4">
                    <v-text-field v-model="client.inn" :label="$t('custom.tax_number')" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3">
                    <v-autocomplete v-model="client.country" flat hide-no-data hide-details
                      :label="$t('custom.country')" :items="countries" item-text="both" item-value="name" outlined>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3">
                    <v-text-field v-model="client.city" :label="$t('custom.city')" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3">
                    <v-text-field v-model="client.address" :label="$t('custom.address')" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="3">
                    <v-select v-model="client.lang" :items="languages" item-text="text" item-value="value"
                      :label="$t('companies.locale')" :placeholder="$t('companies.locale_plc')" outlined></v-select>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4">
                    <v-text-field v-model="client.driver_series" :label="$t('custom.license_series')"
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4">
                    <v-text-field v-model="client.driver_number" :label="$t('custom.license_number')"
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="4">
                    <v-text-field v-model="client.driver_issued" :label="$t('custom.license_issued')"
                      outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12">
                    <v-text-field v-model="client.taxi_license" :label="$t('custom.taxi_license')" outlined :style="user_role == 'guest' || user_role == 'partner'
                      ? 'display: none;'
                      : ''
                      "></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="12">
                    <v-textarea v-model="client.dop_info" clearable rows="1"
                      :label="$t('other.add_client_info_2')"></v-textarea>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("clients.sale_fields") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-text-field v-model="client.sale" :label="$t('custom.sale_perc')" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-text-field v-model="client.sale_cash" :label="$t('custom.sale_rub', { currency: currency })"
                      outlined></v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-text v-else>
          <v-row v-if="client">
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model.trim="client.entity_name" :label="$t('custom.company_name')"
                :placeholder="$t('custom.company_name_placeholder')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model.trim="client.short_entity_name" :label="$t('custom.company_name_short')"
                :placeholder="$t('custom.company_name_short_plc')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model.trim="client.reg_form" :label="$t('custom.reg_form')"
                :placeholder="$t('custom.reg_form_plc')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model.trim="client.inn" :label="$t('custom.tax_number')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model.trim="client.ogrn" :label="$t('custom.entity_number')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4">
              <v-text-field v-model.trim="client.ceo" :label="$t('custom.face')" :placeholder="$t('custom.face_plc')"
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <phone-field ref="clientPhoneField" v-model="client.entity_phone" mode="soft"
                :default-country="phoneDefaultCountry" :label="$t('custom.entity_phone')" outlined />
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2">
              <v-select v-model="client.country" :items="countries" :label="$t('custom.country')" item-text="both"
                item-value="name" outlined></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2">
              <v-text-field v-model.trim="client.city" :label="$t('custom.city')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-textarea v-model.trim="client.entity_adress" :label="$t('custom.entity_address')" outlined rows="1"
                auto-grow></v-textarea>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2">
              <v-select v-model="client.lang" :items="languages" item-text="text" item-value="value"
                :label="$t('companies.locale')" :placeholder="$t('companies.locale_plc')" outlined></v-select>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model.trim="client.acc_number" :label="$t('custom.entity_bank_number')"
                outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2">
              <v-text-field v-model.trim="client.bank" :label="$t('custom.bank_name')"
                :placeholder="$t('custom.bank_name_plc')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="3">
              <v-text-field v-model.trim="client.korr" :label="$t('custom.bank_correspondent')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2">
              <v-text-field v-model.trim="client.bik" :label="$t('custom.bank_number')" outlined></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="2">
              <v-text-field v-model.trim="client.doc_number" :label="$t('custom.doc_number')" outlined></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn id="registration-step-56" color="success" :loading="isLoading" @click="submitClient()">{{ $t("custom.save") }}</v-btn>
          <v-btn @click="newClientDialog = false">{{
            $t("custom.close")
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { personName } from "@/utils/personName";
import { carLabel } from "@/utils/carLabel";
import { requestReviewAfterSuccess } from "@/services/appReviewService";
import moment from "moment";
import { setMomentLocale } from "@/utils/localeInfra";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { extendMoment } from "moment-range";

const moment_range = extendMoment(moment);
// moment.locale("ru");
import { countries } from "./../countries";
import { buildQuoteIdentity, quoteIdentityEquals, formatQuoteDate, seasonModeKey, BookingQuoteRequester, noPriceCauseKey, hasUsableBasePrices, pricesForRentalType } from "./bookingQuote";
import { Capacitor } from "@capacitor/core";
import { buildManualModeOnWarning } from "./manualModeWarning";
import { extraDayReasonKey } from "./extraDayReason";
import BookingAddonsPanel from "@/components/dashboard/bookings/BookingAddonsPanel.vue";
import { depositFieldFor } from "@/components/dashboard/bookings/addonsMath";
import rentalObjectMixin from "@/mixins/rentalObjectMixin";
import { extractValidationDetail } from "@/mixins/setErrorMixin";
import PhoneField from "@/components/common/PhoneField.vue";
import { defaultPhoneCountry } from "@/lib/phone/defaultCountry";
import { phoneLastDigits } from "@/lib/phone/display";
import { phoneFieldsAreValid } from "@/lib/phone/fieldValidation";
import { formatAdjustmentPercent } from "@/utils/adjustmentPercent"; // FT-216

const NEW_CLIENT_COUNTRY_PLACEHOLDER = "Россия";
export default {
  data() {
    return {
      booking: {
        technical: false,
        repair: false,
        car_name: "",
        car_id: 0,
        car_code: "",
        start_date: null,
        end_date: null,
        client_id: null,
        user_id: null,
        sale: 0,
        sale_cash: 0,
        rental_cost_sale: 0,
        rental_cost_sale_cash: 0,
        days: null,
        additional_hours: 0,
        price_hour: 0,
        hours_cost: null,
        rental_cost: null,
        selected_price: null,
        delivery: 0,
        delivery_end: 0,
        clean_payment: 0,
        location_start: this.$t("custom.start_location"),
        location_end: this.$t("custom.start_location"),
        equipment: 0,
        add_drivers_cost: 0,
        insurance: 0,
        other: 0,
        total: null,
        deposit: null,
        hourly_deposit: null,
        weekly_deposit: null,
        monthly_deposit: null,
        description: "",
        taxi_payment_model: 0,
        commission_percent: 0,
      },
      cars_bookings: [],
      car_bookings_dates: [],
      can_select_agents: false,
      agents: [],
      selected_agent_id: null,
      address: "",
      booking_types: [
        { text: this.$t("bookings.daily"), value: "Посуточная" },
        { text: this.$t("bookings.hourly"), value: "Почасовая" },
        { text: this.$t("bookings.weekly"), value: "Понедельная" },
        { text: this.$t("bookings.monthly"), value: "Помесячная" },
      ],
      booking_payments_types: [
        { text: this.$t("bookings.payments_type_full"), value: "full" },
        { text: this.$t("bookings.payments_type_periodic"), value: "periodic" },
      ],
      //   # Модель оплаты: 0 - посуточная, 1 - только процент, 2 - посуточная + процент
      booking_payments_types_taxi: [
        { text: this.$t("taxi.payment_models.daily_rate"), value: 0 },
        { text: this.$t("taxi.payment_models.percent_only"), value: 1 },
        { text: this.$t("taxi.payment_models.daily_plus_percent"), value: 2 },
      ],
      booking_payments_type_taxi: 0,
      taxi_commission_percent: 0,
      booking_periodic_fundings: [
        { text: this.$t("bookings.periodic_funding_balance"), value: "balance" },
        { text: this.$t("bookings.periodic_funding_balance_and_card"), value: "balance_and_card" },
      ],
      booking_periodic_funding: "balance",
      booking_payments_periods: [
        { text: this.$t("bookings.payments_period_daily"), value: "daily" },
        { text: this.$t("bookings.payments_period_weekly"), value: "weekly" },
        { text: this.$t("bookings.payments_period_monthly"), value: "monthly" },
      ],
      booking_selected_type: "Посуточная",
      // true только на время подстановки дефолта компании в
      // booking_selected_type: вотчер типа аренды сбрасывает выбранную
      // машину, и на старте это стирало машину из ?car_id (см. вотчер).
      applyingCompanyRentType: false,
      // Пользователь сам менял тип аренды в селекте: поздний ответ сервера
      // с дефолтом компании после этого перетирать выбор не должен.
      rentTypeTouchedByUser: false,
      booking_payments_type: "full",
      booking_payments_period: "daily",
      customer_category: [
        { text: this.$t("customer_category.new"), value: "Новый" },
        { text: this.$t("customer_category.loyal"), value: "Лояльный" },
        { text: this.$t("customer_category.statement"), value: "Постоянный" },
        { text: this.$t("customer_category.problem"), value: "Серый" },
        { text: this.$t("customer_category.bad"), value: "Чёрный" },
      ],
      languages: [
        { text: this.$t("companies.default_lang"), value: null },
        { text: "English", value: "en" },
        { text: "Русский", value: "ru" },
        { text: "Português (Portugal)", value: "pt" },
        { text: "Português (Brasil)", value: "pt-BR" },
        { text: "Српски", value: "sr" },
        { text: "Thai", value: "th" },
        { text: "Ελληνικά", value: "el" },
        { text: "Hrvatski", value: "hr" },
        { text: "Turkish", value: "tr" },
        { text: "French", value: "fr" },
        { text: "German", value: "de" },
        { text: "Spanish", value: "es" },
        { text: "Italian", value: "it" },
        { text: "Indonesian", value: "id" },
        { text: "Polski", value: "pl" },
        { text: "Română", value: "ro" },
      ],
      start_date: null,
      start_date_with_time: null,
      hours: 0,
      days: 0,
      menu1: false,
      menu2: false,
      birthday_menu: false,
      birthday_date: null,
      birthday_non_format: null,
      end_date: null,
      periods: [],
      periodsHourly: [],
      periodsWeekly: [],
      periodsMonthly: [],
      selected_prices: [],
      end_date_with_time: null,
      masks: {
        // dayPopover: "DD MMM, YYYY",
      },
      calendarConfig: {
        type: "string",
        mask: "DD-MM-YYYY H:mm", // Uses 'iso' if missing,
        // timeAdjust: "12:00:00",
      },
      calendar_attributes: [
        {
          key: "today",
          highlight: {
            color: "red",
            fillMode: "outline",
          },
          dates: new Date(),
        },
      ],
      first_dates_input: true,
      datesRange: {
        // start: moment().set({ hour: 10, minute: 0, second: 0, millisecond: 0 }).subtract(2, 'day').format("DD-MM-YYYY H:mm"),
        // end: moment().set({ hour: 10, minute: 0, second: 0, millisecond: 0 }).subtract(1, 'day').format("DD-MM-YYYY H:mm"),
      },
      bookings_dates: [],
      menu3: false,
      menu4: false,
      cars: [],
      selected_car_id: null,
      selected_tariff: this.$t("custom.standart_tariff"),
      showTariff: false,
      showManualEditing: false,
      // remount-ключ тумблера ручного режима: отмена confirm пересоздаёт
      // переключатель в прежнем положении (:input-value — controlled).
      modeSwitchKey: 0,
      manual_editing: false,
      set_car: null,
      extra: false,
      sale: false,
      clients: [],
      check_clients: [],
      showDescription: false,
      show_payment: false,
      client: {
        name: "",
        lastname: "",
        middlename: "",
        phone: "",
        // Здесь стояло `[this.company ? this.company.country : ""]`, но computed
        // в data() ещё не существуют (Vue 2 инициализирует их ПОСЛЕ data):
        // this.company всегда undefined, и подстановка страны компании не
        // работала ни разу. Оставлено фактическое поведение; если префилл нужен,
        // его место в created(), а не здесь.
        country: [""],
        city: "",
        address: "",
        sale: 0,
        sale_cash: 0,
        passport: "",
        driver: "",
        birthday: null,
      },
      showSelectCountry: false,
      seasons: [],
      selected_season: null,
      selected_seasons: [],
      selected_period: null,
      selected_hourly_period: null,
      selected_weekly_period: null,
      selected_monthly_period: null,
      tariffs: [
        {
          name: this.$t("custom.standart_tariff"),
          fullname: this.$t("custom.standart_tariff"),
        },
      ],
      tariff: null,
      period_max_value: 31,
      hourly_period_max_value: 24,
      weekly_period_max_value: 52,
      monthly_period_max_value: 12,
      add_drivers: [],
      clients_add_drivers: [],
      search_add_driver: null,
      countries: this.$i18n.locale == "ru" ? countries : countries.sort((a, b) => {
        if (a.native < b.native) {
          return -1;
        }
        if (a.native > b.native) {
          return 1;
        }
        return 0;
      }),
      newClientDialog: false,
      showClients: true,
      showAddDrivers: false,
      initialLoading: true,
      isLoading: false,
      ft102DepositTouched: false,
      ft102CatalogCount: 0, // FT-102: есть каталожное оборудование → легаси-галочки скрыты (симметрия SC-08) // FT-102 SC-09: ручная правка отключает автопрефилл залога допов
      ft102AddonsCost: 0, // FT-102 REQ-07: текущая стоимость выбранного оборудования — для превью «К оплате» (сервер добавит её в total после postDraft)
      error: "",
      descriptionLimit: 60,
      entries: [],
      isLoadingClients: false,
      isLoadingClientsAddDriver: false,
      model: null,
      search: null,
      startDate: null,
      endDate: null,
      dateStart: null,
      dateEnd: null,
      dateEndError: null,
      // CRM (FT-055): when navigated from the "Convert lead" flow with ?lead_id,
      // the created booking is attached to this lead on successful save. null = normal flow.
      crmLeadId: null,
      showClientProblems: false,
      warningAddOneDay: false,
      warningLessOneDay: false,
      timeout: null,
      phoneUniqRequestId: 0,
      show_full_fields: false,
      isLoadingGetAgents: false,
      isLoadingGetCar: false,
      isMobile: false,
      errors: "",
      // FT-084 STEP-11: server-side quote state (price_quotes). status:
      // 'idle' (no pricing inputs yet) | 'loading' | 'ready' (quoteIdentity
      // matches current inputs) | 'stale' (inputs changed since last ready
      // quote, new request in flight or about to be) | 'error' (request
      // failed) | 'no_price' (422 no_price — FM-01). Save is blocked unless
      // status === 'ready'.
      quoteStatus: "idle",
      quoteError: null,
      quoteIdentity: null, // identity of the LAST APPLIED (ready) quote
      quoteResponse: null, // raw price_quotes response body of the last applied quote
    };
  },
  beforeDestroy() {
    this._quoteRequester && this._quoteRequester.cancel();
  },
  created() {
    let self = this;
    // FT-084 STEP-11: non-reactive (plain instance field, not in data()) —
    // debounce + stale-response guard over POST /api/v1/price_quotes. Not
    // reactive on purpose: it holds timers/promise bookkeeping, not view state.
    this._quoteRequester = new BookingQuoteRequester({
      post: (payload) =>
        this.axios.post("/api/v1/price_quotes", payload, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        }),
      debounceMs: 350,
    });
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (this.$store.getters.isLoggedIn) {
      this.axios
        .get("/api/v1/active_cars_for_new_booking", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.cars = [];
          response.data.cars.data.forEach((element) => {
            if (element.attributes.active == true) {
              this.cars.push(element.attributes);
            }
          });
          // check if exists params car_id in url
          let url = new URL(window.location.href);
          let car_id = url.searchParams.get("car_id");
          if (car_id && this.cars.length > 0) {
            let finded_car = this.cars.find(car => car.id == car_id);
            if (finded_car) {
              this.selected_car_id = finded_car.id;
              this.getCar(finded_car.id);
            }
          }
          // CRM "Convert lead" flow (FT-055): additively read optional params.
          // When these params are absent, nothing below runs and the page behaves exactly as before.
          let lead_id = url.searchParams.get("lead_id");
          if (lead_id) {
            // String id; the CRM attach_booking endpoint accepts it as a path segment.
            this.crmLeadId = lead_id;
          }
          // FT-058 fix (bug 2026-05-31): client/lead prefill from the EXPLICIT URL param ONLY.
          // We do NOT fall back to an active conversion session here — a lingering session must not
          // leak a client/lead into a normal "New booking" opened without params (the reported bug).
          // The conversion flow always passes lead_id + client_id explicitly via the workspace pickCar URL.
          let effectiveClientId = url.searchParams.get("client_id");
          // Date range prefill. Params arrive as datetime-local strings ("YYYY-MM-DDTHH:mm").
          // We convert them to the component's "DD-MM-YYYY H:mm" format and drive them through
          // datesRange exactly like a manual date entry. We disable first_dates_input so the
          // exact times from the URL are preserved (the watcher's else-branch sets dateStart/
          // dateEnd directly and triggers the normal price-recalc path via the dateEnd watcher).
          let crm_start_date = url.searchParams.get("start_date");
          let crm_end_date = url.searchParams.get("end_date");
          if (crm_start_date && crm_end_date) {
            let parsed_start = moment(crm_start_date, "YYYY-MM-DDTHH:mm");
            let parsed_end = moment(crm_end_date, "YYYY-MM-DDTHH:mm");
            if (parsed_start.isValid() && parsed_end.isValid()) {
              this.first_dates_input = false;
              this.datesRange = {
                // FT-084 dual-review C1: `HH` (zero-padded), not `H` — this
                // sets first_dates_input=false, so the datesRange watcher's
                // else-branch below copies these strings straight into
                // dateStart/dateEnd, which feed requestQuote()/
                // savePricedBooking() verbatim. The server's
                // DATE_FORMAT_REGEX requires a 2-digit hour; moment's `H`
                // token renders single-digit hours unpadded ("9:00"), which
                // would 422 for any CRM-prefilled morning booking.
                start: parsed_start.format("DD-MM-YYYY HH:mm"),
                end: parsed_end.format("DD-MM-YYYY HH:mm"),
              };
            }
          }
          // Client prefill. Fetch the client by id and select it the SAME way the component
          // selects an existing client (GET /api/v1/clients/:id -> this.client = data.client),
          // which fires the existing client() watcher to populate booking.client_id, names, sale, etc.
          // Run after getCar() (which resets this.client synchronously) so our selection wins.
          // client id comes from the explicit URL param only (effectiveClientId).
          if (effectiveClientId) {
            this.$nextTick(() => {
              this.axios
                .get(`api/v1/clients/${effectiveClientId}`, {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                })
                .then((response) => {
                  // Mirror createClient's success handling so the autocomplete + watcher behave identically.
                  const c = response.data.client;
                  if (c) {
                    // The API does not return `fullname`; build it exactly like loadClients() so the
                    // autocomplete (item-text="fullname") can render the selected client.
                    if (!c.entity) {
                      c["fullname"] =
                        personName(c.lastname, c.name, c.middlename) +
                        (c.phone ? " " + phoneLastDigits(c.phone) : "");
                    } else {
                      c["fullname"] =
                        c.entity_name + ", " + c.reg_form + " " + " - " +
                        (c.entity_phone ? phoneLastDigits(c.entity_phone) : "");
                    }
                    // return-object autocomplete only displays a value that is present in :items.
                    if (!this.clients.some((x) => x.id === c.id)) {
                      this.clients = [c, ...this.clients];
                    }
                  }
                  this.client = c;
                  this.booking.client_id = response.data.id;
                  if (this.client && !this.client.entity) {
                    this.booking.fio = response.data.fio;
                  } else {
                    this.booking.entity_name = response.data.entity_name;
                  }
                })
                .catch((error) => {
                  this.setError(error, this.$t("errors.clients_load"));
                });
            });
          }
          // ['1 - 3', '4 - 7', '8 - 14', '15 - 31']
          // со стора приходит неотсортированный массив, нужно отсортировать, но с учетом что там текст
          this.periods = this.sortedPeriods(this.company.periods);
          this.periodsHourly = this.sortedPeriods(this.company.hourly_periods);
          this.periodsWeekly = this.sortedPeriods(this.company.weekly_periods);
          this.periodsMonthly = this.sortedPeriods(this.company.monthly_periods);

          // Дефолт компании применяем ТОЛЬКО если пользователь ещё не выбрал тип
          // сам. Ответ с компанией может прийти поздно — тогда без этой проверки
          // он молча перетирал явный выбор: тип менялся под руками, цены
          // обнулялись, а машина оставалась выбранной (ревью 2026-08-24).
          if (!this.rentTypeTouchedByUser) {
            // Дефолт компании, а не выбор пользователя: вотчер ниже не должен
            // сбрасывать машину, подставленную из ?car_id (/search_free, CRM).
            this.applyingCompanyRentType = true;
            if (this.company.rent_type == 0) {
              this.booking_selected_type = "Посуточная";
            } else if (this.company.rent_type == 1) {
              this.booking_selected_type = "Почасовая";
            } else if (this.company.rent_type == 2) {
              this.booking_selected_type = "Помесячная";
            } else if (this.company.rent_type == 3) {
              this.booking_selected_type = "Понедельная";
            }
            if (this.isTaxiMode) {
              this.booking_selected_type = "Посуточная";
            }
            // Флаг обязан жить ровно один тик. Просто сбросить его внутри вотчера
            // нельзя: вотчер может не сработать вовсе, и флаг залипнет до первого
            // ПОЛЬЗОВАТЕЛЬСКОГО переключения типа, которое тогда не сбросит машину.
            // Два таких случая (оба воспроизведены ревью 2026-08-24): rent_type == 0
            // пишет значение, которое уже стоит; isTaxiMode выше пишет тип дважды за
            // тик, и Vue сравнивает финальное значение со старым. $nextTick-коллбэк
            // регистрируется ПОСЛЕ flushSchedulerQueue, поставленного присваиванием,
            // поэтому защищённый прогон вотчера ещё увидит true, а залипания не будет.
            this.$nextTick(() => {
              this.applyingCompanyRentType = false;
            });
          }

          // Такси-настройки к выбору типа отношения не имеют и применяются всегда.
          if (this.isTaxiMode) {
            if (this.client && this.client.taxi_payment_model) {
              this.booking_payments_type_taxi = this.client.taxi_payment_model;
            }
            if (this.client && this.client.commission_percent) {
              this.taxi_commission_percent = this.client.commission_percent;
            }
          }

          if (this.company.location_start) {
            this.booking.location_start = this.company.location_start;
          }
          if (this.company.location_end) {
            this.booking.location_end = this.company.location_end;
          }

          this.seasons = this.company.seasons;

          let tariff = response.data.tariffs;
          tariff.forEach((item) => {
            let result;
            if (item.sum > 0 || item.sum < 0) {
              result = `${item.sum}${self.currency}`;
            } else {
              result = `${item.percent}%`;
            }
            return (item["fullname"] = `${item.name} | ${result}`);
          });
          this.tariffs = this.tariffs.concat(tariff);
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
        }).finally(() => {
          this.initialLoading = false;
        });
    } else {
      this.$store.commit("unsetCurrentUser");
      this.$router.push({ path: `/signin` }).catch((err) => { });
    }
  },
  mounted: function () {
    if (this.$tours["registrationTour"]) {
      this.$tours["registrationTour"].nextStep();
    }
  },
  watch: {
    search() {
      if (this.client && this.client.id) {
        return;
      }
      if (this.search == "" || this.search == " ") {
        this.search = null;
      } else {
        let self = this;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.loadClients();
          }, 200); // delay
        }
        debounce();
      }
    },
    search_add_driver() {
      // if (this.booking.add_drivers && this.booking.add_drivers.) {
      //   return;
      // }
      if (this.search_add_driver == "" || this.search_add_driver == " ") {
        this.search_add_driver = null;
      } else {
        let self = this;
        function debounce() {
          if (self.timeout) clearTimeout(self.timeout);

          self.timeout = setTimeout(() => {
            // your action
            self.loadClientsAddDrivers();
          }, 200); // delay
        }
        debounce();
      }
    },
    client() {
      // Нужно для того чтобы при выборе клиента из списка, не сбрасывался поиск
      if (this.client == null) {
        this.client = {
          name: "",
          lastname: "",
          middlename: "",
          phone: "",
          country: "",
          city: "",
          address: "",
          sale: 0,
          sale_cash: 0,
          passport: "",
          driver: "",
          birthday: null,
          taxi_payment_model: 0,
          commission_percent: 0,
        };
      }
      if (this.client != "" && this.client != null) {
        this.booking.client_id = this.client.id;
        this.booking.first_name = this.client.name;
        this.booking.middle_name = this.client.middlename;
        this.booking.last_name = this.client.lastname;
        this.booking.sale = this.client.sale ? this.client.sale : 0;
        this.booking.sale_cash = this.client.sale_cash
          ? this.client.sale_cash
          : 0;
        if (this.booking.sale || this.booking.sale_cash) {
          console.log("client sale", this.client.sale, this.client.sale_cash);
          this.sale = true;
          // FT-084 STEP-11: sale/sale_cash are CTR-01 pricing inputs — server
          // applies the discount (was setSale()).
          this.requestQuote();
        }
        this.booking.entity = this.client.entity;
        this.booking.entity_name = this.client.short_entity_name
          ? this.client.short_entity_name + ", " + this.client.reg_form
          : "";
        if (this.client && this.client.birthday) {
          this.checkAge(this.client.birthday);
        }
        if (this.client && this.client.problems) {
          this.showClientProblems = true;
        }
        if (this.client && this.client.taxi_payment_model) {
          this.booking_payments_type_taxi = this.client.taxi_payment_model;
          this.taxi_commission_percent = this.client.commission_percent;
          this.commission_percent = this.client.commission_percent;
        }
      }
    },
    // FT-216 REQ-04: тип платежей — вход квоты (buildCurrentQuoteIdentity): смена перезапрашивает цену.
    booking_payments_type() {
      if (!this.booking.technical) this.requestQuote();
    },
    booking_payments_type_taxi() {
      if (this.isTaxiMode) {
        if (this.booking_payments_type_taxi == 1) {
          this.booking.price = 0;
          this.booking.price_no_sale = 0;
          this.booking.selected_price = 0;
          this.booking.rental_cost = 0;
        }
      }
    },
    booking_selected_type() {
      // Сброс машины был продублирован во всех пяти ветках ниже и выполнялся
      // безусловно. Он нужен, когда тип аренды переключает ПОЛЬЗОВАТЕЛЬ (цены
      // у типов разные), но не когда страница подставляет дефолт компании при
      // загрузке: у компаний с rent_type != 0 это стирало машину из ?car_id
      // ещё до того, как вотчеры дат её проверят, и давало «Не выбран
      // автомобиль!» на переходе из /search_free и из конвертации лида CRM.
      if (!this.applyingCompanyRentType) {
        this.set_car = null;
        this.selected_car_id = null;
      }
      if (this.booking_selected_type == "Посуточная") {
        this.booking.hourly = false;
        this.booking.monthly = false;
        this.booking.weekly = false;

        this.warningLessOneDay = false;
        this.booking.days = 0;
        this.booking.additional_hours = 0;
        this.booking.hours_cost = 0;
        this.booking.rental_cost = 0;
        this.booking.selected_price = 0;
        this.booking.price = 0;
        this.booking.price_hour = 0;
        this.booking.deposit = 0;

        // FT-084 STEP-11: was `this.dateStart = this.dateStart` (self-trigger
        // hack for the old watcher-based calc). Квотировать здесь нечего:
        // при пользовательском переключении типа машина только что сброшена,
        // а при подстановке дефолта компании даты ещё не выставлены (вотчер
        // datesRange идёт позже). В обоих случаях requestQuote() выходит по
        // собственному гарду (вызов оставлен для симметрии/идемпотентности).
        this.requestQuote();
      } else if (this.booking_selected_type == "Почасовая") {
        this.booking.hourly = true;
        this.booking.monthly = false;
        this.booking.weekly = false;
        this.warningLessOneDay = false;
        this.booking.days = 0;
        this.booking.additional_hours = 0;
        this.booking.hours_cost = 0;
        this.booking.rental_cost = 0;
        this.booking.selected_price = 0;
        this.booking.price = 0;
        this.booking.price_hour = 0;
        this.booking.deposit = 0;

        // FT-084 STEP-11: was `this.dateStart = this.dateStart` (self-trigger
        // hack for the old watcher-based calc). Квотировать здесь нечего:
        // при пользовательском переключении типа машина только что сброшена,
        // а при подстановке дефолта компании даты ещё не выставлены (вотчер
        // datesRange идёт позже). В обоих случаях requestQuote() выходит по
        // собственному гарду (вызов оставлен для симметрии/идемпотентности).
        this.requestQuote();
      } else if (this.booking_selected_type == "Понедельная") {
        this.booking.hourly = false;
        this.booking.weekly = true;
        this.booking.monthly = false;
        this.warningLessOneDay = false;
        this.booking.days = 0;
        this.booking.additional_hours = 0;
        this.booking.hours_cost = 0;
        this.booking.rental_cost = 0;
        this.booking.selected_price = 0;
        this.booking.price = 0;
        this.booking.price_hour = 0;
        this.booking.deposit = 0;

        // FT-084 STEP-11: was `this.dateStart = this.dateStart` (self-trigger
        // hack for the old watcher-based calc). Квотировать здесь нечего:
        // при пользовательском переключении типа машина только что сброшена,
        // а при подстановке дефолта компании даты ещё не выставлены (вотчер
        // datesRange идёт позже). В обоих случаях requestQuote() выходит по
        // собственному гарду (вызов оставлен для симметрии/идемпотентности).
        this.requestQuote();
      } else if (this.booking_selected_type == "Помесячная") {
        this.booking.hourly = false;
        this.booking.weekly = false;
        this.booking.monthly = true;
        this.warningLessOneDay = false;
        this.booking.days = 0;
        this.booking.additional_hours = 0;
        this.booking.hours_cost = 0;
        this.booking.rental_cost = 0;
        this.booking.selected_price = 0;
        this.booking.price = 0;
        this.booking.price_hour = 0;
        this.booking.deposit = 0;

        // FT-084 STEP-11: was `this.dateStart = this.dateStart` (self-trigger
        // hack for the old watcher-based calc). Квотировать здесь нечего:
        // при пользовательском переключении типа машина только что сброшена,
        // а при подстановке дефолта компании даты ещё не выставлены (вотчер
        // datesRange идёт позже). В обоих случаях requestQuote() выходит по
        // собственному гарду (вызов оставлен для симметрии/идемпотентности).
        this.requestQuote();
      } else {
        this.booking.hourly = false;
        this.booking.weekly = false;
        this.booking.monthly = false;

        this.warningLessOneDay = false;
        this.booking.days = 0;
        this.booking.additional_hours = 0;
        this.booking.hours_cost = 0;
        this.booking.rental_cost = 0;
        this.booking.selected_price = 0;
        this.booking.price = 0;
        this.booking.price_hour = 0;
        this.booking.deposit = 0;

        // FT-084 STEP-11: was `this.dateStart = this.dateStart` (self-trigger
        // hack for the old watcher-based calc). Квотировать здесь нечего:
        // при пользовательском переключении типа машина только что сброшена,
        // а при подстановке дефолта компании даты ещё не выставлены (вотчер
        // datesRange идёт позже). В обоих случаях requestQuote() выходит по
        // собственному гарду (вызов оставлен для симметрии/идемпотентности).
        this.requestQuote();
      }
    },
    datesRange() {
      // При первом вводе дат, ставим время 10:00
      if (this.datesRange.start && this.datesRange.end && this.first_dates_input) {
        console.log("datesRange", this.datesRange);

        // Сохраняем временную копию объекта
        const tempDatesRange = { ...this.datesRange };

        // Устанавливаем флаг first_dates_input в false перед изменением объекта
        this.first_dates_input = false;

        // Используем nextTick чтобы обновление выполнилось после текущего цикла рендеринга
        this.$nextTick(() => {
          const startWithTime = moment(tempDatesRange.start, "DD-MM-YYYY H:mm")
            .set({ hour: 10, minute: 0, second: 0, millisecond: 0 })
            .format("DD-MM-YYYY H:mm");
          const endWithTime = moment(tempDatesRange.end, "DD-MM-YYYY H:mm")
            .set({ hour: 10, minute: 0, second: 0, millisecond: 0 })
            .format("DD-MM-YYYY H:mm");

          // Задержка перед установкой нового значения
          setTimeout(() => {
            this.datesRange = {
              start: startWithTime,
              end: endWithTime
            };
            console.log("datesRange updated", this.datesRange);

            // Принудительно обновляем значения dateStart и dateEnd
            this.dateStart = startWithTime;
            this.dateEnd = endWithTime;
          }, 50);
        });
      } else {
        // FT-084 dual-review C1: v-calendar's own mask token `H` (calendarConfig
        // above) does NOT zero-pad the hour, so datesRange.start/end can arrive
        // straight from the picker as "05-07-2026 9:00". requestQuote()
        // (buildCurrentQuoteIdentity) and savePricedBooking() read
        // dateStart/dateEnd verbatim, and the server's DATE_FORMAT_REGEX
        // requires a 2-digit hour — normalize here (not just at payload time)
        // so the displayed value and the quote identity stay consistent (same
        // pattern as BookingCard.vue setDates() / ProlongDialog.vue).
        this.dateStart = this.datesRange.start
          ? moment(this.datesRange.start, "DD-MM-YYYY H:mm").format("DD-MM-YYYY HH:mm")
          : this.datesRange.start;
        this.dateEnd = this.datesRange.end
          ? moment(this.datesRange.end, "DD-MM-YYYY H:mm").format("DD-MM-YYYY HH:mm")
          : this.datesRange.end;
      }
    },
    // FT-084 STEP-11: was ~1050 lines of client-side seasonal/period/hourly-
    // limit math (season lookup, period-tier selection, sale/tariff
    // application) — see task-11-report.md for the removed branch list. Now:
    // reset sale/tariff (non-pricing UX reset, preserved verbatim), validate
    // date order, request a server quote (debounced), and run the
    // availability check (checkBookingsDates — unrelated to pricing).
    dateEnd() {
      if (this.set_car) {
        // Обнуляем тариф и скидки, но оставляем скидки если есть в клиенте
        this.booking.sale = this.client.sale ? this.client.sale : 0;
        this.booking.sale_cash = this.client.sale_cash ? this.client.sale_cash : 0;
        this.booking.rental_cost_sale = 0;
        this.booking.rental_cost_sale_cash = 0;
        this.booking.tariff_id = null;
        this.booking.tariff = null;
        this.selected_tariff = this.$t("custom.standart_tariff");

        if (
          this.dateStart &&
          moment
            .utc(this.dateStart, "DD-MM-YYYY H:mm")
            .isSameOrBefore(moment.utc(this.dateEnd, "DD-MM-YYYY H:mm"), "minute")
        ) {
          this.errors = [];
          this.dateEndError = false;
          this.requestQuote();
        } else {
          this.$notify(this.$t("errors.incorrect_date_title"), this.$t("errors.incorrect_date_text"), "warning", 5000);
        }
        // Проверка на доступность
        if (this.dateStart && this.dateEnd) {
          this.checkBookingsDates(this.set_car, this.dateStart, this.dateEnd);
        }
      } else {
        this.$notify(this.$t("errors.select_car_title"), this.$t("errors.select_car_text"), "warning", 5000);
      }
    },
    // FT-084 STEP-11: mirror of dateEnd (see comment above) — was ~1050 lines
    // of client-side seasonal/period/hourly-limit math, replaced by a single
    // debounced server quote request. Non-pricing reset (sale/tariff) and the
    // availability check (checkBookingsDates) preserved verbatim.
    dateStart() {
      if (this.set_car) {
        // Обнуляем тариф и скидки, но оставляем скидки если есть в клиенте
        this.booking.sale = this.client.sale ? this.client.sale : 0;
        this.booking.sale_cash = this.client.sale_cash ? this.client.sale_cash : 0;
        this.booking.rental_cost_sale = 0;
        this.booking.rental_cost_sale_cash = 0;
        this.booking.tariff_id = null;
        this.booking.tariff = null;
        this.selected_tariff = this.$t("custom.standart_tariff");

        if (this.dateEnd) {
          this.requestQuote();
        }

        // Проверка на доступность
        if (this.dateStart && this.dateEnd) {
          this.checkBookingsDates(this.set_car, this.dateStart, this.dateEnd);
        }
      } else {
        this.$notify(this.$t("errors.select_car_title"), this.$t("errors.select_car_text"), "warning", 5000);
      }
    },
    selected_tariff() {
      if (this.selected_tariff) {
        this.tariff = this.tariffs.find((tariff) => {
          return tariff.id == this.selected_tariff;
        });
        // FT-084 STEP-11: tariff {sum,percent} is now a CTR-01 pricing input
        // (Pricing::Engine applies it server-side) — was calculateCostWithTariff().
        this.requestQuote();
      }
    },
    birthday_non_format: function (val) {
      if (val && val.length == 10) {
        this.client.birthday = moment(val, "DD.MM.YYYY").format("YYYY-MM-DD");
      }
    },
    // FT-084 STEP-11 (DEC-06): toggling manual mode changes how requestQuote()
    // resolves pricingReady (manual = ready immediately from typed values;
    // non-manual = needs a fresh server quote) — re-run it on every flip so
    // the Save gate and shown numbers reflect the new mode right away.
    manual_editing() {
      this.requestQuote();
    },
  },
  mixins: [rentalObjectMixin],
  computed: {
    // FT-166: причина отказа no_price выводится из rental_type, который форма
    // и так отправила в запросе квоты, — сервер об этом спрашивать не нужно.
    noPriceMessageKey() {
      return noPriceCauseKey(this.currentRentalType());
    },
    // Посуточную предлагаем только тогда, когда посуточные цены действительно
    // заполнены. Совет, который сам приведёт к 422, хуже отсутствия совета.
    noPriceCanTryDaily() {
      if (this.currentRentalType() !== "hourly") return false;
      return hasUsableBasePrices(pricesForRentalType(this.set_car, "daily"));
    },
    // Обычный href, а не только обработчик: если браузер заблокирует открытие
    // новой вкладки, ссылка остаётся рабочей штатными средствами браузера.
    carPricesHref() {
      const id = (this.set_car && this.set_car.id) || this.booking.car_id;
      if (!id) return null;
      return this.$router.resolve({ name: "CarCard", params: { id: String(id) } }).href;
    },
    // FT-102 (DEC-01): единица тарификации брони для per_unit-допов
    ft102Units() {
      const b = this.booking;
      if (b.hourly) return Number(b.hourly_hours) || 1;
      if (b.weekly) return Number(b.weekly_weeks) || 1;
      if (b.monthly) return Number(b.monthly_months) || 1;
      return Number(b.days) || 1;
    },
    // Пояснение «почему добавлены сутки» из ответа движка (FT-084 units.extra_day_reason):
    // порог компании (hours_limit) или ценовое правило «допчасы дороже суток», которое
    // действует независимо от настройки. Пустая строка = сутки за остаток не добавляли.
    // Только авто-режим: при включении ручного quoteResponse не обнуляется (запрос лишь
    // отменяется), и подсказка залипала бы от последней авто-квоты (ревью 2026-07-31).
    extraDayReasonText() {
      if (this.manual_editing) return "";
      const key = extraDayReasonKey(this.quoteResponse);
      return key ? this.$t(key) : "";
    },
    main_company() {
      return this.$store.getters.getMainCompany;
    },
    company() {
      return this.$store.getters.getCompany.company;
    },
    // FT-208 CTR-03: страна клиента, иначе страна филиала. У нового клиента «Россия» — заглушка
    // формы при «Новый» (NEW_CLIENT_COUNTRY_PLACEHOLDER), а не выбор пользователя: тогда берём филиал.
    phoneDefaultCountry() {
      const client = this.client || {};
      const placeholder = !client.id && client.country === NEW_CLIENT_COUNTRY_PLACEHOLDER;
      return defaultPhoneCountry({ client: placeholder ? null : client, company: this.company });
    },
    // FT-193: источник списания выбирают только при автопродлении и работающем терминале Т-Банка
    // (company.tinkoff_operable считает сервер). Иначе ключа в запросе нет — поведение прежнее.
    showPeriodicFunding() {
      return this.booking_payments_type === "periodic" && !!(this.company && this.company.tinkoff_operable);
    },
    // Панель «Сезоны»: режим определения сезона (manual QA 2026-07-13).
    // Первоисточник — meta.season_mode ответа квоты (режим компании МАШИНЫ,
    // по нему считал движок; при брони машины другого филиала он отличается
    // от компании юзера); fallback — флаги компании юзера из Vuex.
    seasonModeKeyValue() {
      const fromQuote = this.quoteResponse && this.quoteResponse.meta && this.quoteResponse.meta.season_mode;
      return fromQuote || seasonModeKey(this.company);
    },
    seasonModeText() {
      const key = this.seasonModeKeyValue;
      return key ? this.$t("bookings.season_mode_" + key) : "";
    },
    isTaxiMode() {
      return this.company && this.company.taxi_park_type && this.company.taxi_park_type !== 'not_taxi';
    },
    minDate() {
      if (this.dateStart) {
        return moment(this.dateStart, "DD-MM-YYYY H:mm").toDate();
      } else {
        return undefined;
      }
    },
    clients_sources() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.clients_sources
      ) {
        return this.$store.getters.getCompany.company.clients_sources;
      } else {
        return [];
      }
    },
    currency() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        this.$store.getters.getCompany.company.currency
      ) {
        return this.$store.getters.getCompany.company.currency;
      } else {
        return "";
      }
    },
    short_client_view() {
      return this.$store.getters.getUserSettings.short_client_view;
    },
    // FT-084 STEP-11 (FM-07): true only when the shown numbers were computed
    // for EXACTLY the current pricing inputs (quoteIdentity matches). Any
    // pricing-input change immediately invalidates this even before the new
    // debounced request lands (buildCurrentQuoteIdentity is cheap/sync).
    quoteIsFresh() {
      if (this.booking.technical) return true; // technical bookings skip pricing entirely
      if (this.quoteStatus !== "ready") return false;
      return quoteIdentityEquals(this.quoteIdentity, this.buildCurrentQuoteIdentity());
    },
    // Gates the Save button (FM-07: "пока для текущих входов нет актуальной
    // квоты — сохранение заблокировано"; FM-05: request error blocks save;
    // FM-01: no_price blocks save).
    pricingReady() {
      if (this.booking.technical) return true; // no pricing inputs to validate
      // FT-084 STEP-15 (I-1 fix): manual-mode fields (selected_price,
      // deposit, service costs) have no requote trigger (@blur/@input) — the
      // manager editing them changes buildCurrentQuoteIdentity() without
      // ever refreshing quoteIdentity/quoteStatus, so quoteIsFresh would go
      // (and stay) false and strand Save. DEC-06: in manual mode the applied
      // price is whatever was typed — the server always recomputes/accepts
      // manual_price on save (CTR-03) — so freshness isn't a save precondition.
      if (this.manual_editing) return true;
      return this.quoteIsFresh;
    },
  },
  methods: {
    // Копия, а не sort() на месте: массив — из компании в сторе.
    sortedPeriods(periods) {
      return periods.slice().sort((a, b) => a.split('-')[0] - b.split('-')[0]);
    },
    carLabel,
    // ------------------------------------------------------------------
    // FT-084 STEP-11: server-side quote (POST /api/v1/price_quotes) replaces
    // the client-side seasonal math that used to live in setSale/
    // calculateCostWithExtra/calculateCostWithTariff/setDailySeasons + the
    // dateStart/dateEnd/dateStartUpdate watcher bodies (see task-11-report.md
    // for the full list of removed methods/branches).
    // ------------------------------------------------------------------

    // Current rental_type string per CTR-01 (daily|hourly|weekly|monthly),
    // derived from the same three booleans the legacy code branched on.
    currentRentalType() {
      if (this.booking.hourly) return "hourly";
      if (this.booking.weekly) return "weekly";
      if (this.booking.monthly) return "monthly";
      return "daily";
    },

    // FT-166: предупреждение при выборе объекта — о ценах ТОГО типа аренды,
    // который сейчас оформляется, и по тому же признаку, что и у сервера:
    // пустой values базовой строки, а не отсутствие самой строки. Прежняя
    // проверка на наличие строки пропускала машину с базовой строкой и пустым
    // values — она молча доходила до 422 no_price.
    //
    // Проверка best-effort: если машину выбрали ДО переключения на почасовую,
    // активный тип здесь ещё другой. Авторитетный сигнал — баннер квоты.
    warnIfPricesMissing(car) {
      const rentalType = this.currentRentalType();
      if (hasUsableBasePrices(pricesForRentalType(car, rentalType))) return;
      this.$notify(
        this.$t("bookings.quote_no_price_title"),
        this.$t(noPriceCauseKey(rentalType)),
        "warning",
        5000
      );
    },

    // FT-166: вкладка передаётся через персистентный Vuex (crmPersistReducer
    // кладёт car_tab в ...rest), поэтому доезжает и до новой вкладки браузера.
    // На вебе открываем именно новую вкладку — иначе несохранённая форма брони
    // теряется. Под Capacitor вкладок нет, там обычный переход.
    onOpenCarPrices(event) {
      this.$store.commit("setCarTab", "prices");
      // Зовётся и на auxclick (средняя кнопка): браузер открывает вкладку сам,
      // минуя @click, и без коммита она открылась бы на «Бронях». Перехват
      // нужен только нативу, где вкладок нет.
      if (!Capacitor.isNativePlatform()) return;
      if (event && event.preventDefault) event.preventDefault();
      const id = (this.set_car && this.set_car.id) || this.booking.car_id;
      this.$router.push({ name: "CarCard", params: { id: String(id) } });
    },

    // Builds the CTR-01 pricing-input identity from current form state. Used
    // both to send the request and to compare "is the shown quote still
    // valid for the current inputs" (quoteStatus derivation).
    buildCurrentQuoteIdentity() {
      return buildQuoteIdentity({
        carId: this.booking.car_id,
        startAt: this.dateStart,
        endAt: this.dateEnd,
        rentalType: this.currentRentalType(),
        sale: this.booking.sale,
        saleCash: this.booking.sale_cash,
        rentalCostSale: this.booking.rental_cost_sale,
        rentalCostSaleCash: this.booking.rental_cost_sale_cash,
        tariff: this.tariff,
        gifts: [],
        services: {
          delivery: this.booking.delivery,
          delivery_end: this.booking.delivery_end,
          equipment: this.booking.equipment,
          insurance: this.booking.insurance,
          clean_payment: this.booking.clean_payment,
          add_drivers_cost: this.booking.add_drivers_cost,
          other: this.booking.other,
          deposit: this.currentDeposit(),
        },
        priceHour: null,
        manualPrice: this.manual_editing ? this.booking.selected_price : null,
        // FT-216 REQ-04: сервер выбирает поправки на даты по типу платежей (periodic — без них), как при сохранении
        // (savePricedBooking шлёт тот же booking_payments_type) — иначе квота показала бы цену с поправкой.
        paymentsType: this.booking_payments_type,
      });
    },

    // Debounced quote request (FM-07): call on every pricing-input change.
    // While in flight (or before the first quote arrives) the previously
    // shown numbers are marked stale and Save is blocked (pricingReady
    // computed) — CTR-03 makes this safe even if the user manages to save
    // on stale numbers, since the server always recomputes authoritatively.
    requestQuote() {
      if (!this.set_car || !this.booking.car_id || !this.dateStart || !this.dateEnd) {
        // FT-084 dual-review V-1: bump _seq (cancel()) even on this early
        // exit — a previously in-flight request's .then()/.catch() (attached
        // by an earlier requestQuote() call) would otherwise still see
        // mySeq === _seq when it resolves and clobber booking.* via
        // applyQuoteResponse() after the inputs went missing.
        this._quoteRequester.cancel();
        this.quoteStatus = "idle";
        return;
      }
      // Равные/инвертированные даты — промежуточное состояние формы (даты
      // по умолчанию совпадают, пользователь ещё крутит поля), а НЕ ошибка:
      // квоту не запрашиваем (сервер честно 422-ил бы нулевой интервал),
      // панель цены остаётся нейтральной. Решение USER 2026-07-22.
      if (!moment(this.dateEnd, "DD-MM-YYYY HH:mm").isAfter(moment(this.dateStart, "DD-MM-YYYY HH:mm"))) {
        this._quoteRequester.cancel();
        this.quoteStatus = "idle";
        return;
      }
      // Manual editing: no server round-trip needed for the numbers
      // (DEC-06 — the applied price is whatever the user typed), but we
      // still keep pricingReady true so Save isn't blocked. total/rental_cost
      // stay exactly as the user edited them in the manual fields.
      if (this.manual_editing) {
        // FT-084 dual-review V-1: cancel() any in-flight auto-quote request
        // (bumps _seq) BEFORE returning — otherwise a stale response that
        // lands after manual mode is enabled would still pass the
        // mySeq===_seq guard and applyQuoteResponse() would overwrite the
        // manually-typed booking.selected_price.
        this._quoteRequester.cancel();
        this.quoteStatus = "ready";
        this.quoteError = null;
        this.quoteIdentity = this.buildCurrentQuoteIdentity();
        return;
      }

      const identity = this.buildCurrentQuoteIdentity();
      this.quoteStatus = "loading";
      this.quoteError = null;

      this._quoteRequester
        .request(identity)
        .then((response) => {
          this.applyQuoteResponse(response.data, identity);
        })
        .catch((error) => {
          // FM-01: 422 no_price — machine-readable code, explicit state
          // distinct from a generic request error (FM-05).
          const code = extractValidationDetail(error).code;
          if (error.response && error.response?.status === 422 && code === "no_price") {
            this.quoteStatus = "no_price";
          } else {
            this.quoteStatus = "error";
          }
          this.quoteError = error;
        });
    },

    // Applies a price_quotes response (CTR-02) onto booking.* — the exact
    // set of fields the template reads (data-cy="days"/"price_no_sale"/
    // "selected_price"/"total"/"deposit" etc.) plus the season breakdown
    // table (selected_seasons, data-cy="days_in_season"/"price_in_season").
    applyQuoteResponse(quote, identity) {
      this.quoteStatus = "ready";
      this.quoteIdentity = identity;
      this.quoteResponse = quote;

      const rentalType = this.currentRentalType();

      this.booking.days = quote.units.days;
      this.booking.additional_hours = quote.units.hours_less_day > 0 && Number(quote.totals.hours_cost) > 0 ? quote.units.hours_less_day : 0;
      this.booking.price_no_sale = Number(quote.totals.price_no_sale);
      this.booking.selected_price = Number(quote.totals.selected_price);
      this.booking.rental_cost = Number(quote.totals.rental_cost);
      this.booking.hours_cost = Number(quote.totals.hours_cost);
      this.booking.total = Number(quote.totals.total);
      this.booking.price = Number(quote.totals.selected_price);

      if (rentalType === "hourly") {
        this.booking.hourly_hours = quote.units.days;
      } else if (rentalType === "weekly") {
        this.booking.weekly_weeks = quote.units.days;
      } else if (rentalType === "monthly") {
        this.booking.monthly_months = quote.units.days;
      }

      // Season breakdown table (template `selected_seasons`, v-for over
      // {season: {start_date, end_date, id}, days, price, isBase}) — mapped
      // from ALL rental_unit line items: base-price groups (season_id=null)
      // тоже показываем в панели «Сезоны» (manual QA 2026-07-13). Line items
      // already come pre-aggregated per season/qty from the Engine.
      this.selected_seasons = quote.line_items
        .filter((item) => item.kind === "rental_unit")
        .map((item, index) => ({
          index,
          isBase: item.season_id == null,
          season: {
            id: item.season_id,
            // CTR-02 отдаёт ISO "YYYY-MM-DD"; в таблице сезонов показываем
            // "DD-MM-YYYY" (manual QA 2026-07-13).
            start_date: formatQuoteDate(item.starts_on),
            end_date: formatQuoteDate(item.ends_on),
          },
          days: item.qty,
          price: item.unit_price,
          // FT-216 CTR-05: у старого api поля нет — пустая строка, суффикс не рисуется
          adjustmentPercent: formatAdjustmentPercent(item.adjustment_percent),
        }));

      // Taxi percent-only mode (legacy dateEnd watcher tail): booking price
      // is fully zeroed regardless of the quote — commission is computed
      // elsewhere. Preserved verbatim as a post-quote override.
      if (this.isTaxiMode && this.booking_payments_type_taxi == 1) {
        this.booking.price = 0;
        this.booking.price_no_sale = 0;
        this.booking.selected_price = 0;
        this.booking.rental_cost = 0;
      }

      // min_days-порог задан в календарных сутках и осмыслен только для
      // суточного тарифа. Для hourly/weekly/monthly booking.days хранит
      // биллинговые ЕДИНИЦЫ (часы/недели/месяцы, см. applyQuoteResponse и
      // pricing/engine.rb), а не сутки — безусловная проверка давала ложную
      // тревогу «Бронь создаётся на N суток» на недельной/месячной броне.
      // Гард зеркалит канон BookingCard.vue.
      if (!this.booking.hourly && !this.booking.weekly && !this.booking.monthly) {
        this.checkDaysMinLimit(this.booking.days);
      }
    },

    getCar(event) {
      let self = this;
      this.isLoadingGetCar = true;
      if (event) {
        this.set_car = this.cars.filter((x) => x.id === event)[0];
        console.log("set_car", this.set_car);
      }
      // # { id: 3, state: "Критическое состояние" },
      // # { id: 4, state: "В долгосрочной аренде" },
      // # { id: 5, state: "Не выдавать" },
      if (this.set_car.state == 3) {
        this.$notify(this.$t("states.car_critical"), "", "warning", 5000);
      } else if (this.set_car.state == 4) {
        this.$notify(this.$t("states.car_long_rent"), "", "warning", 5000);
      } else if (this.set_car.state == 5) {
        this.$notify(this.$t("states.car_no_rent"), "", "warning", 5000);
      }
      this.booking.car_id = this.set_car.id;
      this.booking.car_code = this.set_car.code;
      this.booking.car_name = this.set_car.car_name;
      this.booking.price_hour = this.set_car.price_hour;
      this.booking.deposit = this.set_car.deposit;
      this.booking.hourly_deposit = this.set_car.hourly_deposit;
      this.booking.weekly_deposit = this.set_car.weekly_deposit;
      this.booking.monthly_deposit = this.set_car.monthly_deposit;

      // Обнуляем тариф и скидки при смене авто и клиента
      // Обнуляем тариф и скидки, но оставляем скидки если есть в клиенте
      this.booking.sale = this.client.sale ? this.client.sale : 0;
      this.booking.sale_cash = this.client.sale_cash ? this.client.sale_cash : 0;
      this.booking.rental_cost_sale = 0;
      this.booking.rental_cost_sale_cash = 0;
      this.booking.tariff_id = null;
      this.booking.tariff = null;
      this.selected_tariff = this.$t("custom.standart_tariff");
      this.client = {
        name: "",
        lastname: "",
        middlename: "",
        phone: "",
        country: this.company.country || this.company.country_code || "",
        city: "",
        address: "",
        sale: 0,
        sale_cash: 0,
        passport: "",
        driver: "",
        birthday: null,
        taxi_payment_model: 0,
        commission_percent: 0,
      };

      this.axios
        .get(`/api/v1/show_for_new_booking/${this.set_car.id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          // Если set_car обнулился (например, сменили тип бронирования) — выходим
          if (!this.set_car) return;

          this.calendar_attributes = [
            {
              key: "today",
              highlight: {
                color: "red",
                fillMode: "outline",
              },
              dates: new Date(),
            },
          ];
          response.data.bookings_dates.forEach((booking) => {
            this.calendar_attributes.push({
              highlight: {
                start: { fillMode: "outline" },
                base: { fillMode: "light" },
                end: { fillMode: "outline" },
              },
              content: "black",
              dates: {
                start: moment(booking.start, "DD-MM-YYYY H:mm").toDate(),
                end: moment(booking.end, "DD-MM-YYYY H:mm").toDate(),
              },
              popover: {
                label: `${booking.start} - ${booking.end}`,
                visibility: "hover",
                hideIndicator: true,
              },
            });
          });

          if (response.data.car.prices.length > 0) {
            if (response.data.car.prices.some((e) => e.season_id === null)) {
              this.set_car["prices"] = response.data.car.prices;
              if (this.dateStart) {
                // Обновляю вотчер методом дублем, а то при перевыборе авто цены не менялись
                this.dateStartUpdate();
              }
            }
          } else {
            this.set_car["prices"] = [];
          }
          if (response.data.car.hourly_prices.length > 0) {
            if (response.data.car.hourly_prices.some((e) => e.season_id === null)) {
              this.set_car["hourly_prices"] = response.data.car.hourly_prices;
              if (this.dateStart) {
                // Обновляю вотчер методом дублем, а то при перевыборе авто цены не менялись
                this.dateStartUpdate();
              }
            }
          } else {
            this.set_car["hourly_prices"] = [];
          }
          if (response.data.car.weekly_prices.length > 0) {
            if (response.data.car.weekly_prices.some((e) => e.season_id === null)) {
              this.set_car["weekly_prices"] = response.data.car.weekly_prices;
              if (this.dateStart) {
                // Обновляю вотчер методом дублем, а то при перевыборе авто цены не менялись
                this.dateStartUpdate();
              }
            }
          } else {
            this.set_car["weekly_prices"] = [];
          }
          if (response.data.car.monthly_prices.length > 0) {
            if (response.data.car.monthly_prices.some((e) => e.season_id === null)) {
              this.set_car["monthly_prices"] = response.data.car.monthly_prices;
              if (this.dateStart) {
                // Обновляю вотчер методом дублем, а то при перевыборе авто цены не менялись
                this.dateStartUpdate();
              }
            }
          } else {
            this.set_car["monthly_prices"] = [];
          }
          // FT-166: раньше на каждый из четырёх типов цен стояло по два
          // generic-тоста, и половина из них срабатывала независимо от
          // оформляемого типа аренды — на машине без почасовых цен сотрудник
          // получал тревогу и на посуточной броне. Предупреждение потеряло
          // смысл именно из-за этого шума. Вызов ОДИН и после всех четырёх
          // блоков: иначе на недельной броне старый тост и новый наложились бы
          // друг на друга (находка ревью 2026-09-21).
          this.warnIfPricesMissing(response.data.car);
          this.cars_bookings = response.data.active_bookings.data.map((element) => {
            return element.attributes;
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.set_car"));
        })
        .finally(() => (this.isLoadingGetCar = false));
    },
    // FT-084 STEP-11: non-technical bookings now save through
    // POST /api/v1/priced_bookings (server-authoritative recompute, CTR-03) —
    // technical bookings (price-free, booking.technical=true) keep using the
    // legacy POST /api/v1/bookings endpoint verbatim (CON-10: legacy path is
    // NOT modified). STEP-11 fix round 1: priced_bookings#create/update now
    // accepts `technical`/`repair` for persistence (no price-free branch —
    // this form still routes technical bookings through the legacy endpoint
    // above, by design; see task-11-report.md "Fix round 1").
    saveBooking() {
      // проверяем на должника
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
        this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
        return;
      }
      // Агент здесь ЯВНО допущен: оформление брони — его основная работа,
      // /booking/new первым пунктом в его меню (Drawer). Голый isStaff тут
      // отключил бы роль целиком.
      if (this.isStaff || this.isAgent) {
        if (
          this.booking.client_id == null ||
          this.booking.car_code == "" ||
          this.set_car == null ||
          this.dateStart == null ||
          this.dateEnd == null
        ) {
          this.$notify(this.$t("errors.required_params_title"), this.$t("errors.required_params_text"), "warning", 5000);
          return;
        }
        // FM-07 (task-11-brief.md §2): while the shown numbers aren't a fresh
        // server quote for the CURRENT inputs, saving is blocked.
        if (!this.booking.technical && !this.pricingReady) {
          this.$notify(this.$t("bookings.quote_not_ready_title"), this.$t("bookings.quote_not_ready_text"), "warning", 5000);
          return;
        }

        this.isLoading = true;

        if (this.booking.technical) {
          this.saveTechnicalBooking();
        } else {
          this.savePricedBooking();
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },

    // Legacy path (unchanged payload/endpoint) — technical bookings carry no
    // pricing at all, so there is nothing for priced_bookings to compute.
    // Предупреждение при включении ручного режима (USER 2026-07-21):
    // блокирующий confirm с конкретными последствиями — движок отключится,
    // панель сохранится как введено. Отмена = remount тумблера.
    async onManualSwitchToggle(value) {
      const next = !!value;
      if (next === this.showManualEditing) return;
      if (next) {
        const confirmed = await this.$confirm({
          title: this.$t("bookings.manual_on_title"),
          html: buildManualModeOnWarning({
            context: "create",
            prolongsCount: 0,
            t: (key, params) => this.$t(key, params),
          }),
          icon: "mdi-alert-outline",
          iconColor: "warning",
          iconSize: 72,
          iconPosition: "top",
          confirmButtonText: this.$t("bookings.manual_on_confirm"),
          confirmButtonColor: "primary",
          cancelButtonText: this.$t("custom.cancel"),
          cancelButtonColor: "grey darken-1",
          useFilledButtons: true,
          maxWidth: 520,
        });
        if (!confirmed) {
          this.modeSwitchKey++;
          return;
        }
      }
      this.showManualEditing = next;
      this.manual_editing = next;
    },
    saveTechnicalBooking() {
      let deposit = 0;
      if (!this.booking.hourly && !this.booking.weekly && !this.booking.monthly) {
        deposit = this.booking.deposit;
      } else if (this.booking.hourly) {
        deposit = this.booking.hourly_deposit;
      } else if (this.booking.weekly) {
        deposit = this.booking.weekly_deposit;
      } else if (this.booking.monthly) {
        deposit = this.booking.monthly_deposit;
      }
      this.axios
        .post(
          "/api/v1/bookings",
          {
            bookings: {
              manual_editing: this.manual_editing,
              hourly: this.booking.hourly,
              weekly: this.booking.weekly,
              monthly: this.booking.monthly,
              car_name: this.booking.car_name,
              car_id: this.booking.car_id,
              car_code: this.booking.car_code,
              start_date: moment(this.dateStart, "DD-MM-YYYY H:mm").format("DD-MM-YYYY H:mm"),
              end_date: moment(this.dateEnd, "DD-MM-YYYY H:mm").format("DD-MM-YYYY H:mm"),
              client_id: this.booking.client_id,
              first_name: this.booking.first_name,
              middle_name: this.booking.middle_name,
              last_name: this.booking.last_name,
              company_id: this.set_car.company_id,
              sale: 0,
              sale_cash: 0,
              days: this.booking.days,
              additional_hours: this.booking.additional_hours,
              hourly_hours: this.booking.hourly_hours,
              weekly_weeks: this.booking.weekly_weeks,
              monthly_months: this.booking.monthly_months,
              price: 0,
              price_no_sale: 0,
              price_id: this.booking.price_id,
              rental_cost: 0,
              price_hour: 0,
              hours_cost: 0,
              delivery: this.booking.delivery,
              delivery_end: this.booking.delivery_end,
              clean_payment: this.booking.clean_payment,
              insurance: this.booking.insurance,
              kasko: this.booking.kasko,
              super_kasko: this.booking.super_kasko,
              theft: this.booking.theft,
              no_franchise: this.booking.no_franchise,
              location_start: this.booking.location_start,
              location_end: this.booking.location_end,
              equipment: this.booking.equipment,
              other: this.booking.other,
              total: this.booking.total,
              chair: this.booking.chair,
              chair_less_1_year: this.booking.chair_less_1_year,
              chairs_quantity: this.booking.chairs_quantity,
              booster: this.booking.booster,
              boosters_quantity: this.booking.boosters_quantity,
              navigator: this.booking.navigator,
              mp3: this.booking.mp3,
              charger: this.booking.charger,
              deposit: 0,
              hourly_deposit: 0,
              weekly_deposit: 0,
              monthly_deposit: 0,
              description: this.booking.description,
              entity: this.booking.entity,
              entity_name: this.booking.entity_name,
              add_drivers: this.booking.add_drivers,
              add_drivers_cost: this.booking.add_drivers_cost,
              state: "Активная",
              custom_field_1: this.booking.custom_field_1,
              custom_field_2: this.booking.custom_field_2,
              custom_field_3: this.booking.custom_field_3,
              technical: this.booking.technical,
              repair: this.booking.repair,
              tariff_id: this.booking.tariff_id,
              payments_type: this.booking_payments_type,
              payments_period: this.booking_payments_type && this.booking_payments_type == "periodic" ? this.booking_payments_period : null,
              ...(this.showPeriodicFunding ? { periodic_funding: this.booking_periodic_funding } : {}),
              agent_id: this.selected_agent_id,
              taxi_payment_model: this.booking_payments_type_taxi,
              commission_percent: this.taxi_commission_percent,
            },
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then(async (response) => {
          await this.afterBookingSaved(response.data.id);
        })
        .catch((error) => {
          if (error.response?.status == 402) {
            this.$notify(this.$t("errors.balance_not_enough_new_booking_title"), this.$t("errors.balance_not_enough_new_booking_text"), "warning", 5000);
          } else {
            this.setError(error, this.$t("errors.add_booking_title"));
          }
        })
        .finally(() => (this.isLoading = false));
    },

    // FT-084 STEP-11 (CTR-01/CTR-03): server recomputes price authoritatively
    // from the same pricing inputs the last shown quote used — an in-flight
    // stale quote is harmless (CTR-03), pricingReady above just avoids
    // showing/saving numbers we know are already outdated for the current
    // form inputs.
    savePricedBooking() {
      const identity = this.buildCurrentQuoteIdentity();
      const payload = {
        car_id: identity.car_id,
        client_id: this.booking.client_id,
        start_at: this.dateStart,
        end_at: this.dateEnd,
        rental_type: this.currentRentalType(),
        sale: identity.sale,
        sale_cash: identity.sale_cash,
        rental_cost_sale: identity.rental_cost_sale,
        rental_cost_sale_cash: identity.rental_cost_sale_cash,
        tariff: identity.tariff,
        gifts: identity.gifts,
        services: identity.services,
        deposit: this.currentDeposit(),
        manual_price: this.manual_editing ? this.booking.selected_price : null,
        // Ручной режим: ВСЯ панель ручного редактирования уходит как прямые
        // override'ы (полный легаси-паритет, USER 2026-07-21) — юниты,
        // доп. часы, аренда и итог напрямую. Сервер применяет их только при
        // manual_price; в авторежиме цифры считает движок (CTR-03). Раньше
        // введённое в панели молча терялось и «отпрыгивало» после сейва.
        ...(this.manual_editing
          ? {
              days: this.booking.days,
              hourly_hours: this.booking.hourly_hours,
              weekly_weeks: this.booking.weekly_weeks,
              monthly_months: this.booking.monthly_months,
              additional_hours: this.booking.additional_hours,
              hours_cost: this.booking.hours_cost,
              rental_cost: this.booking.rental_cost,
              total: this.booking.total,
            }
          : {}),
        description: this.booking.description,
        location_start: this.booking.location_start,
        location_end: this.booking.location_end,
        entity: this.booking.entity,
        entity_name: this.booking.entity_name,
        custom_field_1: this.booking.custom_field_1,
        custom_field_2: this.booking.custom_field_2,
        custom_field_3: this.booking.custom_field_3,
        car_code: this.booking.car_code,
        payments_type: this.booking_payments_type,
        // FT-084 STEP-11 fix round 1 (task-11-report.md §4 gap list): the
        // legacy unified saveBooking() payload (see saveTechnicalBooking()
        // above, extracted verbatim) also sent these non-pricing fields for
        // every booking, technical or not. priced_bookings#create/update now
        // accepts them (NON_PRICING_PERMITTED_FIELDS parity fix) — restore
        // them here so non-technical bookings created through this form no
        // longer silently drop them. Nothing price-derived is added (days/
        // price/rental_cost/total/etc. stay server-computed, CTR-03).
        car_name: this.booking.car_name,
        first_name: this.booking.first_name,
        middle_name: this.booking.middle_name,
        last_name: this.booking.last_name,
        kasko: this.booking.kasko,
        super_kasko: this.booking.super_kasko,
        theft: this.booking.theft,
        no_franchise: this.booking.no_franchise,
        chair: this.booking.chair,
        chair_less_1_year: this.booking.chair_less_1_year,
        chairs_quantity: this.booking.chairs_quantity,
        booster: this.booking.booster,
        boosters_quantity: this.booking.boosters_quantity,
        navigator: this.booking.navigator,
        mp3: this.booking.mp3,
        charger: this.booking.charger,
        add_drivers: this.booking.add_drivers,
        hourly_deposit: this.booking.hourly_deposit,
        weekly_deposit: this.booking.weekly_deposit,
        monthly_deposit: this.booking.monthly_deposit,
        state: "Активная",
        tariff_id: this.booking.tariff_id,
        payments_period: this.booking_payments_type && this.booking_payments_type == "periodic" ? this.booking_payments_period : null,
        ...(this.showPeriodicFunding ? { periodic_funding: this.booking_periodic_funding } : {}),
        agent_id: this.selected_agent_id,
        taxi_payment_model: this.booking_payments_type_taxi,
        commission_percent: this.taxi_commission_percent,
      };

      this.axios
        .post("/api/v1/priced_bookings", payload, {
          headers: { Authorization: this.$store.getters.getAuthToken },
        })
        .then(async (response) => {
          await this.afterBookingSaved(response.data.booking.id);
        })
        .catch((error) => {
          if (error.response && error.response?.status == 402) {
            this.$notify(this.$t("errors.balance_not_enough_new_booking_title"), this.$t("errors.balance_not_enough_new_booking_text"), "warning", 5000);
          } else {
            this.setError(error, this.$t("errors.add_booking_title"));
          }
        })
        .finally(() => (this.isLoading = false));
    },

    // Shared post-save flow (CRM lead attach + redirect + toast), extracted
    // verbatim from the old saveBooking().then() so both save paths share it.
    // FT-102 (REQ-08): префилл залога допов, пока менеджер не правил поле вручную.
    // Поле — по типу аренды (ревью PR-B: у hourly/weekly/monthly залог в своих полях)
    ft102OnAddonsDepositChanged({ delta }) {
      if (this.ft102DepositTouched || !delta) return;
      const field = depositFieldFor(this.booking);
      this.booking[field] = Math.round(((Number(this.booking[field]) || 0) + delta) * 100) / 100;
      // deposit входит в идентичность квоты (FT-084 FM-07) — программное
      // изменение без requote замораживало Save (quoteIsFresh=false навсегда)
      if (!this.booking.technical) this.requestQuote();
    },
    // Task 8: договорная цена/залог позиции черновика меняют предполагаемые
    // суммы программно — освежаем квоту, иначе гейт FT-084 (quoteIsFresh)
    // заморозит «Создать» (тот же класс, что и ft102OnAddonsDepositChanged).
    ft102OnDraftPricingChanged() {
      if (!this.booking.technical) this.requestQuote();
    },
    async afterBookingSaved(bookingId) {
      // FT-102: постим выбранные допы строками (сервер валидирует остаток;
      // отказ по допу не роняет созданную бронь — покажется предупреждение)
      if (this.$refs.addonsPanel) {
        await this.$refs.addonsPanel.postDraft(bookingId);
      }
      // CRM "Convert lead" flow (FT-055): if we arrived with a lead_id, attach the
      // freshly created booking to that lead (the API links the booking and derives the
      // client; the stage is NOT touched since 2026-06-17 — the lead is won by the
      // manager, or on issue/return if the tenant enabled auto-win). Guarded so normal
      // booking creation is completely unaffected. A failure here must NOT fail the
      // booking — it was created.
      if (this.crmLeadId) {
        // FT-056 (REQ-08/09): confirm before attaching the created booking to the lead.
        const session = this.$store.getters["crm/conversionByLead"](this.crmLeadId);
        const leadLabel = (session && session.leadName) || ("#" + this.crmLeadId);
        // Booking is already created at this point; stop the Save button spinner
        // while the user decides in the $confirm dialog.
        this.isLoading = false;
        const ok = await this.$confirm({ title: this.$t("crm.convert.confirm_attach", { name: leadLabel }) });
        if (ok) {
          try {
            await this.axios.post(
              `/api/v1/crm/leads/${this.crmLeadId}/attach_booking`,
              { booking_id: bookingId },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            );
            this.$store.commit("crm/CLEAR_CONVERSION", this.crmLeadId); // REQ-09: только сессия этого лида
            this.$notify(this.$t("crm.toast.lead_booking_attached"), "", "success");
          } catch (attachError) {
            console.log("CRM attach_booking failed", attachError);
            this.$notify(this.$t("crm.toast.network_error"), "", "warning", 5000);
          }
        }
        // ok === false -> booking created, NOT attached, session stays active (REQ-08/EDGE-09)
      }
      this.$router.replace(`/bookings/${bookingId}`);
      this.$notify(this.$t("bookings.add_booking_title"), this.$t("bookings.add_booking_text"), "success", 3000);
      // Созданная бронь — «победный» момент для нативного запроса оценки в
      // сторе. Сервис сам проверяет платформу/роль/возраст компании/частоту,
      // ждёт 1.5 с (чтобы не перекрыть тост) и никогда не бросает.
      requestReviewAfterSuccess(this.$store);
    },
    loadClients() {
      this.isLoadingClients = true;
      this.axios
        .post(
          `/api/v1/index_new_booking_page`,
          {
            search: this.search,
            meilisearch: true,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.clients = response.data.query ? response.data.query : (response.data ? response.data : []);
          this.clients.forEach((client) => {
            if (!client.entity) {
              client["fullname"] =
                personName(client.lastname, client.name, client.middlename) +
                (client.phone
                  ? " " + phoneLastDigits(client.phone)
                  : "");
            } else {
              client["fullname"] =
                client.entity_name +
                ", " +
                client.reg_form +
                " " +
                " - " +
                (client.entity_phone
                  ? phoneLastDigits(client.entity_phone)
                  : "");
            }
          });
        })
        .catch((error) => {
          this.isLoadingClients = false;
          this.setError(error, this.$t("errors.clients_load"));
          console.log(error);
        })
        .finally(() => (this.isLoadingClients = false));
    },
    loadClientsAddDrivers() {
      this.isLoadingClientsAddDriver = true;
      this.axios
        .post(
          `/api/v1/index_new_booking_page`,
          {
            search: this.search_add_driver,
            meilisearch: true,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.clients_add_drivers = response.data.query ? response.data.query : (response.data ? response.data : []);
          this.clients_add_drivers.forEach((client) => {
            if (!client.entity) {
              client["fullname"] =
                personName(client.lastname, client.name, client.middlename) +
                (client.phone
                  ? " " + phoneLastDigits(client.phone)
                  : "");
            } else {
              client["fullname"] =
                client.entity_name +
                ", " +
                client.reg_form +
                " " +
                " - " +
                (client.entity_phone
                  ? phoneLastDigits(client.entity_phone)
                  : "");
            }
          });
        })
        .catch((error) => {
          this.isLoadingClientsAddDriver = false;
          this.setError(error, this.$t("errors.clients_load"));
          console.log(error);
        })
        .finally(() => (this.isLoadingClientsAddDriver = false));
    },
    checkDaysMinLimit(days) {
      // Гарды выровнены с BookingCard.vue: не тревожим при отсутствии
      // company/min_days и на технических (ремонтных) бронях.
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company &&
        !this.booking.technical &&
        this.$store.getters.getCompany.company.min_days &&
        days < this.$store.getters.getCompany.company.min_days
      ) {
        this.$notify(this.$t("bookings.low_days_title"), this.$t("bookings.low_days_text", { days: days }), "warning", 5000);
      }
    },
    checkAge(date) {
      if (date) {
        let startDate = moment(date, ["DD.MM.YYYY", "YYYY-MM-DD"]);
        let endDate = moment();
        let years = moment.duration(endDate.diff(startDate)).years();

        if (years < this.$store.getters.getCompany.company.age_limit) {
          this.$notify(this.$t("bookings.low_age_title"), this.$t("bookings.low_age_text", { years: parseInt(years) }), "warning", 5000);
        }
      }
    },
    checkUniqClientPhone() {
      const phone = this.client && this.client.phone;
      const requestId = (this.phoneUniqRequestId || 0) + 1;
      this.phoneUniqRequestId = requestId;
      if (!phone) return Promise.resolve();

      return this.axios
        .post(
          "/api/v1/check_client_uniqueness",
          { phone },
          { headers: { Authorization: this.$store.getters.getAuthToken } }
        )
        .then((response) => {
          if (requestId !== this.phoneUniqRequestId) return;
          if (response.data && response.data.length > 0) {
            this.$notify(this.$t("bookings.phone_uniq_title"), this.$t("bookings.phone_uniq_text"), "warning", 5000);
          }
        })
        .catch(() => undefined);
    },
    checkUniqClientEmail() {
      if (
        this.client.email &&
        this.check_clients.filter((client) => client.email == this.client.email)
          .length > 0
      ) {
        this.$notify(this.$t("bookings.email_uniq_title"), this.$t("bookings.email_uniq_text"), "warning", 5000);
      }
    },
    submitClient() {
      // проверяем на должника
      if (this.$store.getters.getMainCompany && this.$store.getters.getMainCompany.payer_state == 3) {
        this.$notify(this.$t("errors.payer_state_3_title"), this.$t("errors.payer_state_3_text"), "warning", 10000);
        return;
      }
      if (!phoneFieldsAreValid(this.$refs && this.$refs.clientPhoneField)) return;
      // Агент допущен: без создания клиента бронь не оформить (см. saveBooking).
      if (this.isStaff || this.isAgent) {
        this.isLoading = true;
        let client = this.client;
        let middlename, year, birthday;

        if (client.middlename) {
          middlename = this.capitalizeFirst(client.middlename);
        } else {
          middlename = "";
        }
        if ((client.name && client.lastname) || client.entity) {
          this.newClientDialog = false;
          this.showClients = false;

          let name = client.name ? this.capitalizeFirst(client.name) : "";
          let lastname = client.lastname
            ? this.capitalizeFirst(client.lastname)
            : "";
          if (client.birthday) {
            console.log(client.birthday);
            birthday = client.birthday;

            year = birthday.split("-")[0];
          }

          this.axios
            .post(
              "/api/v1/clients.json",
              {
                clients: {
                  name: name,
                  lastname: lastname,
                  middlename: middlename,
                  fio:
                    middlename && !client.entity
                      ? name[0] + ". " + middlename[0] + ". " + lastname
                      : name[0] + ". " + lastname,
                  email: client.email,
                  phone: client.phone,
                  country: client.country,
                  city: client.city,
                  address: client.address,
                  sale: client.sale,
                  sale_cash: client.sale_cash,
                  passport_series: client.passport_series,
                  passport_number: client.passport_number,
                  passport_issued: client.passport_issued,
                  passport_issued_date: client.passport_issued_date,
                  passport_expired_date: client.passport_expired_date,
                  driver_series: client.driver_series,
                  driver_number: client.driver_number,
                  driver_issued: client.driver_issued,
                  driver_issued_date: client.driver_issued_date,
                  driver_expired_date: client.driver_expired_date,
                  birthday: client.birthday ? client.birthday : null,
                  year: year,
                  category: client.category,
                  dop_info: client.dop_info,
                  entity: client.entity,
                  entity_name: client.entity_name,
                  short_entity_name: client.short_entity_name,
                  ceo: client.ceo,
                  reg_form: client.reg_form,
                  entity_phone: client.entity_phone,
                  entity_adress: client.entity_adress,
                  inn: client.inn,
                  ogrn: client.ogrn,
                  acc_number: client.acc_number,
                  bank: client.bank,
                  korr: client.korr,
                  bik: client.bik,
                  doc_number: client.doc_number,
                  source: client.source,
                  taxi_license: client.taxi_license,
                },
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then((response) => {
              this.axios
                .get(`api/v1/clients/${response.data.id}`, {
                  headers: {
                    Authorization: this.$store.getters.getAuthToken,
                  },
                })
                .then((response) => {
                  this.client = response.data.client;
                  this.booking.client_id = response.data.id;
                  if (this.client && !this.client.entity) {
                    this.booking.fio = response.data.fio;
                  } else {
                    this.booking.entity_name = response.data.entity_name;
                  }
                  this.birthday_date = null;
                })
                .catch((error) => {
                  this.setError(error, this.$t("errors.clients_load"));
                });
            })
            .then(() => {
              this.$notify(this.$t("custom.add_client_title"), this.$t("custom.add_client_text"), "success", 3000);
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.add_client_title"));
            })
            .finally(() => (this.isLoading = false));
        } else {
          this.$notify(this.$t("errors.all_fields_title"), this.error, "warning", 5000);
          this.isLoading = false;
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    onStartChange(selectedDates, dateStr, instance) {
      this.$set(this.configEnd, "minDate", dateStr);
    },
    capitalizeFirst(text) {
      return text[0].toUpperCase() + text.substring(1).toLowerCase();
    },
    // FT-084 STEP-11: was a third ~1050-line copy of the same seasonal math
    // as dateStart/dateEnd (forced re-trigger after getCar() loads car
    // prices, since dateStart itself hasn't changed value). Now: reset
    // sale/tariff, request a server quote, run availability check.
    dateStartUpdate() {
      if (this.set_car) {
        // Обнуляем тариф и скидки, но оставляем скидки если есть в клиенте
        this.booking.sale = this.client.sale ? this.client.sale : 0;
        this.booking.sale_cash = this.client.sale_cash ? this.client.sale_cash : 0;
        this.booking.rental_cost_sale = 0;
        this.booking.rental_cost_sale_cash = 0;
        this.booking.tariff_id = null;
        this.booking.tariff = null;
        this.selected_tariff = this.$t("custom.standart_tariff");

        this.requestQuote();

        // Проверка на доступность
        if (this.dateStart && this.dateEnd) {
          this.checkBookingsDates(this.set_car, this.dateStart, this.dateEnd);
        }
      } else {
        this.$notify(this.$t("errors.select_car_title"), this.$t("errors.select_car_text"), "warning", 5000);
      }
    },
    getAgents() {
      this.isLoadingGetAgents = true;
      this.axios
        .get("/api/v1/get_agents", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          let active_agents = response.data.filter(agent => agent.active == true);
          this.agents = active_agents;
        })
        .catch((error) => {
          this.setError(error, "Something went wrong in getAgents");
          console.log(error);
        })
        .finally(() => (this.isLoadingGetAgents = false));
    },
    checkBookingsDates(car, start_date, end_date) {
      let self = this;
      if (car && start_date && end_date) {
        // let start_date = checked_booking.start_date;
        // let end_date = checked_booking.end_date;
        // let cars_bookings = this.bookings.filter(booking => {
        //   return booking.car_id === car.id && booking.id != checked_booking.id;
        // });
        self.cars_bookings.forEach((booking) => {
          let checked_start_date = moment(start_date, "DD-MM-YYYY H:mm");
          let checked_end_date = moment(end_date, "DD-MM-YYYY H:mm");
          let booking_start_date = moment(
            booking.start_date,
            "DD-MM-YYYY H:mm"
          ).subtract(
            self.$store.getters.getCompany.company.interval_bookings,
            "hours"
          );
          let booking_end_date = moment(
            booking.end_date,
            "DD-MM-YYYY H:mm"
          ).add(
            self.$store.getters.getCompany.company.interval_bookings,
            "hours"
          );
          if (
            checked_start_date.isBetween(
              booking_start_date,
              booking_end_date,
              "hour"
            ) ||
            checked_end_date.isBetween(
              booking_start_date,
              booking_end_date,
              "hour"
            ) ||
            booking_start_date.isBetween(
              checked_start_date,
              checked_end_date,
              "hour"
            ) ||
            booking_end_date.isBetween(
              checked_start_date,
              checked_end_date,
              "hour"
            )
          ) {
            self.$notify(self.$t("errors.booked_title"), self.$t("errors.booked_text"), "warning", 5000);
          }
        });
      }
    },
    toClientCard(client) {
      const route = this.$router.resolve(`/clients/${client.id}`);
      window.open(route.href, '_blank');
    },
    currentDeposit() {
      if (!this.booking.hourly && !this.booking.weekly && !this.booking.monthly) {
        let check_number = Number(this.booking.deposit) === this.booking.deposit;
        return check_number ? parseFloat(this.booking.deposit.toFixed(2)) : 0;
      } else if (this.booking.hourly) {
        let check_number = Number(this.booking.hourly_deposit) === this.booking.hourly_deposit;
        return check_number ? parseFloat(this.booking.hourly_deposit.toFixed(2)) : 0;
      } else if (this.booking.weekly) {
        let check_number = Number(this.booking.weekly_deposit) === this.booking.weekly_deposit;
        return check_number ? parseFloat(this.booking.weekly_deposit.toFixed(2)) : 0;
      } else if (this.booking.monthly) {
        let check_number = Number(this.booking.monthly_deposit) === this.booking.monthly_deposit;
        return check_number ? parseFloat(this.booking.monthly_deposit.toFixed(2)) : 0;
      } else {
        let check_number = Number(this.booking.deposit) === this.booking.deposit;
        return check_number ? parseFloat(this.booking.deposit.toFixed(2)) : 0;
      }
    },
    getClientInfo(event) {
      let client = this.clients.filter((x) => x.id === event)[0];
      this.booking.client_id = event;
      this.booking.fio = client.fio;
      this.client = client;
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
  },
  components: {
    BookingAddonsPanel,
    PhoneField,
  },
};
</script>
<style>
div.vc-time-picker {
  /* centring */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
}
</style>
